import { getRenderableScheduleData } from "./scheduleDataSnapshot";
import { reconcileRoleFilter } from "./scheduleRoleFilter";
import { completeAutoschedulePreview } from "./autoscheduleRequest";
import { hasActualHoursSource } from "./schedule_components/scheduledCoverage";
import React, { useState, useEffect } from "react";
import useActualComplianceAudit from "./schedule_components/useActualComplianceAudit";
import { getEmployeeMainRole } from "./schedule_components/employeeMainRole";
import ActionBarDisplay2 from "./action_bar_components/ActionBarDisplay2";
import ScheduleDisplay2 from "./schedule_components/ScheduleDisplay2";
import { buildAutoscheduleAcceptance } from "./autoscheduleAcceptance";
import { getStoreBusinessDate } from "../../../utilities/storeTime";
import CustomizeSummaryCardsModal from "./schedule_components/CustomizeSummaryCardsModal";
import {
  DEFAULT_CARD_ORDER,
  sanitizeCardOrder,
} from "./schedule_components/summaryCardRegistry";
import {
  employeeHasRoleInDepartments,
  getDefaultScheduleRole,
  getEmployeeRolesInDepartments,
} from "./schedule_components/departmentFilter";
import {
  shouldResolveOpenShiftRequest,
} from "./schedule_components/openShiftAssignment";
import { getRightworkAPI } from "../requests/utilities/requests";
import TopBarDisplay from "./top_bar_components/TopBarDisplay";
import DailyTopBarDisplay from "../plan/daily_top_bar_components/DailyTopBarDisplay";
import MonthlyTopBarDisplay from "./top_bar_components/MonthlyTopBarDisplay";
import axios from "axios";
import {
  API_get_forecasted_sales_daily,
  API_get_forecasted_transactions_daily,
  API_get_forecasted_other_daily,
  API_get_adjustments_chosen,
  API_get_adjustments_history,
  API_get_forecasted_labor,
  API_get_actual_schedule,
  API_get_actual_schedule_labor_deployment,
  API_get_store_team_members,
  API_store_team_member_set_order,
  API_load_prev_week_schedule,
  API_load_employee_prev_week_schedule,
  API_get_template_names,
  API_save_schedule_as_template,
  API_load_schedule_from_template,
  API_delete_schedule_template,
  API_edit_shift,
  API_manager_assign_open_shift,
  API_get_default_availability,
  API_request_time_off,
  API_get_request_off,
  API_edit_availability,
  API_get_role_names,
  API_update_team_member_info,
  API_auto_schedule,
  API_accept_auto_schedule,
  API_delete_all_shifts,
  API_publish_schedule,
  API_get_actual_sales_daily,
  API_get_actual_other_daily,
  API_get_calculated_earned_labor,
  API_get_actual_used_labor_vs_earned,
  API_add_forecast_adjustment,
  API_get_manual_intraday_distribution,
  API_save_manual_intraday_distribution,
  API_add_manual_actual_sales,
  API_edit_multiple_shifts,
  API_get_default_operating_hours,
  API_edit_operating_hours,
  API_get_daily_operating_hours,
  API_get_role_types,
  API_get_weather,
  API_get_events,
  API_save_event,
  API_update_event,
  API_delete_event,
  API_attach_event_file,
  API_remove_event_file,
  API_delete_file_upload,
  API_get_batch_guidance,
  API_get_intraday_metrics,
  API_get_actual_intraday_metrics,
  API_get_local_events,
  API_get_all_time_off_requests,
  API_get_published_shift_count,
  API_get_station_info,
  API_get_forecast_exclude_dates,
  API_save_forecast_exclude_date,
  API_delete_forecast_exclude_date,
  API_get_blackout_dates,
  API_create_blackout_date,
  API_delete_blackout_date,
  API_get_reservation_summary,
  API_get_spent_labor_daily_summaries,
  API_get_recent_avg_wages,
  API_list_frequent_schedules,
  API_get_historical_sales_context,
  API_get_grade_weights,
  API_post_missed_shift,
  API_get_copilot_schedule,
  API_get_copilot_status,
  API_delete_time_off_request,
  API_delete_temporary_availability,
  API_get_actual_used_schedule,
  API_get_published_schedule_actions,
  API_get_surveys_for_date_range,
  API_get_summary_card_preferences,
} from "../../../constants";

import { getDefaultAxiosConfig } from "../../../utilities/requests";
import { get_t_str, getRoleType, formatName } from "../../../helpers/helpers";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { postRightworkAPI, uploadFile } from "../requests/utilities/requests";
import useAutoschedulerDebugStore from "../../../stores/autoschedulerDebugStore";
import AutoschedulerDebugModal from "./schedule_components/AutoschedulerDebugModal";
import LoadSpinner from "../../../utilities/LoadSpinner";
import {
  SHIFT_MUTATION_REFRESH_API_CALLS,
  SHIFT_MUTATION_REFRESH_DATA_NAMES,
} from "./scheduleRefreshBundles";
import { getStartOfCurrentWeek } from "./scheduleDate";

const DEFERRED_INITIAL_DATA_DEFAULTS = {
  adjustments_history: [],
  //weather: [],
  batch_guidance: {},
  actual_intraday_metrics: {},
  local_events: [],
  forecast_exclude_dates: [],
  reservation_summary: [],
  get_spent_labor_daily_summaries: [],
  recent_avg_wages: [],
  frequent_schedules: {},
  copilot_schedule: [],
  intraday_metrics: {},
  published_schedule_actions: {},
  surveys: [],
};
const DEFERRED_INITIAL_DATA_NAMES = new Set(
  Object.keys(DEFERRED_INITIAL_DATA_DEFAULTS)
);
const STORE_SCOPED_INITIAL_DATA_NAMES = new Set([
  "store_team_members",
  "role_types",
  "role_names",
]);

function ScheduleNavigationLoadingState() {
  return (
    <div className="flex min-h-[calc(100vh-120px)] w-full items-center justify-center">
      <div className="flex flex-col items-center gap-3 text-center">
        <div className="flex h-8 w-8 items-center justify-center">
          <LoadSpinner />
        </div>
        <p className="text-sm font-medium text-slate-500">
          Loading schedule...
        </p>
      </div>
    </div>
  );
}

const DEFAULT_SCHEDULE_COMPARISON_METRIC_VISIBILITY = {
  coverage_score: true,
  budget_score: true,
  keyholder_coverage_percent: false,
  minimum_staffing_coverage_percent: false,
  role_distribution_match_percent: false,
  opening_closing_consistency_score: false,
  target_hours_score: false,
  schedule_consistency_score: false,
  shift_consistency_score: false,
  schedule_warnings_score: false,
};

function HomeDisplay2(props) {
  const [displayMode, setDisplayMode] = React.useState(false);
  const [minimizeMode, setMinimizeMode] = React.useState(() => {
    const saved = localStorage.getItem('rightwork_minimizeMode');
    return saved !== null ? saved === 'true' : false;
  });
  const [showWeeklySummaryCards, setShowWeeklySummaryCards] = React.useState(() => {
    const saved = localStorage.getItem('rightwork_showWeeklySummaryCards');
    return saved !== null ? saved === 'true' : false;
  });
  // Labor bar: metric cards vs intraday charts. Per-user preference.
  const [bottomCardType, setBottomCardType] = React.useState(
    () => localStorage.getItem("rightwork_bottomCardType") || "metric"
  );
  React.useEffect(() => {
    localStorage.setItem("rightwork_bottomCardType", bottomCardType);
  }, [bottomCardType]);
  const [summaryCardOrder, setSummaryCardOrder] =
    React.useState(DEFAULT_CARD_ORDER);
  const [customizeSummaryCardsOpen, setCustomizeSummaryCardsOpen] =
    React.useState(false);

  React.useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await getRightworkAPI(
          API_get_summary_card_preferences,
          {},
        );
        if (cancelled) return;
        const saved = res?.data?.redux?.payload?.card_ids;
        setSummaryCardOrder(sanitizeCardOrder(saved));
      } catch (e) {
        if (!cancelled) setSummaryCardOrder(DEFAULT_CARD_ORDER);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);
  const [roleType, setRoleType] = React.useState([]);
  const [roleTypeOptions, setRoleTypeOptions] = React.useState([]);
  const roleFilterInitializedRef = React.useRef(false);
  const roleFilterSelectAllRef = React.useRef(true);
  const roleFilterStoreRef = React.useRef(props.homeStore);
  const roleTypeRef = React.useRef(roleType);
  const roleTypeOptionsRef = React.useRef(roleTypeOptions);
  roleTypeRef.current = roleType;
  roleTypeOptionsRef.current = roleTypeOptions;

  const [filtered, setFiltered] = React.useState([]);
  const [selectedRolesForFiltering, setSelectedRolesForFiltering] =
    React.useState([]);
  const [sorted, setSorted] = React.useState(
    props.scheduleInitialView?.viewMode === "Day" ? "shift_start" : ""
  );
  const [segmentMode, setSegmentMode] = React.useState(
    localStorage.getItem('rightwork_segmentMode') || "default"
  );
  const [reorderMode, setReorderMode] = React.useState(false);
  const [showWarnings, setShowWarnings] = React.useState(false);
  const [searchInput, setSearchInput] = React.useState("");
  const [noMatchingSearch, setNoMatchingSearch] = React.useState(false);
  const [showUnpublishedShifts, setShowUnpublishedShifts] =
    React.useState(false);

  const [showLaborPercent, setShowLaborPercent] = React.useState(
    props.laborPercentEnabled
  );

  const comparisonMetricVisibility = {
    ...DEFAULT_SCHEDULE_COMPARISON_METRIC_VISIBILITY,
    ...(props.comparisonMetricVisibility || {}),
  };

  const [week_start_date, set_week_start_date] = useState(() => {
    const renderDate = props.scheduleRenderDate
      ? getStartOfCurrentWeek(
          props.businessWeekStartDayIndex,
          props.scheduleRenderDate
        )
      : null;
    if (renderDate && !isNaN(renderDate.getTime())) {
      return renderDate;
    }

    // Load saved week start date from localStorage
    const saved = localStorage.getItem('rightwork_selectedWeekStart');

    if (saved) {
      const savedDate = new Date(saved);
      // Validate it's a valid date
      if (!isNaN(savedDate.getTime())) {
        return savedDate;
      }
    }
    // Fallback to current week
    return getStartOfCurrentWeek(
      props.businessWeekStartDayIndex,
      props.scheduleRenderDate
    );
  });

  // Whether the schedule is reading actuals rather than the plan. This lives
  // here rather than inside ScheduleDisplay2 because the top bar needs it too:
  // a count of what is wrong with the schedule, or a control that rewrites it,
  // has no business being live while the board shows what actually happened.
  // The store's date, not the viewer's. A manager whose calendar has already
  // rolled over would otherwise have the week declared finished and be dropped
  // into Actual while the store was still working its last day.
  const scheduleWeekInPast = () =>
    formatDate(addDays(week_start_date, 6)) <
    getStoreBusinessDate(props.storeTimezone, props.start_qhnum);
  const [scheduleShowsActuals, setScheduleShowsActuals] = useState(
    scheduleWeekInPast
  );
  useEffect(() => {
    setScheduleShowsActuals(scheduleWeekInPast());
    // Store included: whether the week is finished is answered in the store's
    // own time, so switching stores near a boundary changes the answer without
    // the week moving.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    // props.homeStore rather than store_id: that alias is declared far below
    // this effect, and naming it here reaches it before initialization.
  }, [
    week_start_date,
    props.homeStore,
    props.storeTimezone,
    props.start_qhnum,
  ]);

  // The store's own date decides whether the displayed week has begun, so a
  // viewer in another timezone does not switch the pair on early.
  //
  // Held in state because a board left open has to cross midnight on its own.
  // Read once at render it would freeze on the day it mounted, and the
  // quarter-hour clock in ScheduleDisplay2 would then roll past 24 back to the
  // new day's start hour while this still named yesterday, which reads as an
  // overnight shift that has not happened yet. Setting the same date is not a
  // state change, so this renders about once a day.
  const [scheduleStoreBusinessDate, setScheduleStoreBusinessDate] = useState(
    () => getStoreBusinessDate(props.storeTimezone, props.start_qhnum)
  );
  useEffect(() => {
    const syncBusinessDate = () => {
      const next = getStoreBusinessDate(props.storeTimezone, props.start_qhnum);
      setScheduleStoreBusinessDate((current) =>
        current === next ? current : next
      );
    };
    syncBusinessDate();
    const timer = setInterval(syncBusinessDate, 60000);
    return () => clearInterval(timer);
  }, [props.storeTimezone, props.start_qhnum]);
  const scheduleWeekStartStr = week_start_date
    ? formatDate(new Date(week_start_date.toDateString()))
    : null;
  const scheduleWeekHasStarted =
    !scheduleWeekStartStr ||
    scheduleWeekStartStr <= scheduleStoreBusinessDate;
  const [currentMonth, setCurrentMonth] = useState(
    props.scheduleInitialView?.currentMonth ?? new Date().getMonth()
  );
  const [currentYear, setCurrentYear] = useState(
    props.scheduleInitialView?.currentYear ?? new Date().getFullYear()
  );
  const [all_data_full, set_all_data_full] = useState({
    store_team_members: [],
  });
  const all_data_full_ref = React.useRef(all_data_full);
  const [all_data, set_all_data] = useState({ store_team_members: [] });
  const initialScheduleLoadingRef = React.useRef(false);
  const scheduleContext = `${props.homeStore}:${week_start_date.getTime()}`;
  const latestScheduleContextRef = React.useRef(scheduleContext);
  latestScheduleContextRef.current = scheduleContext;
  const scheduleLoadGenerationRef = React.useRef(0);
  const dataRequestGenerationRef = React.useRef({});
  const storeScopedInitialDataRef = React.useRef({ storeId: null, data: {} });
  const latestScheduleStoreIdRef = React.useRef(props.homeStore);
  latestScheduleStoreIdRef.current = props.homeStore;

  const actualHoursAvailable = hasActualHoursSource(
    props.storeNames?.find(store => String(store.id) === String(props.homeStore)),
    Number(storeScopedInitialDataRef.current.storeId) === Number(props.homeStore)
      ? all_data_full.actual_used_schedule : []
  );
  const scheduleActualHoursVisible =
    scheduleShowsActuals && scheduleWeekHasStarted && actualHoursAvailable;

  // Warning mode groups the roster by warnings and is left by a control in the
  // top bar. Actual mode hides that control along with the warnings themselves,
  // which would strand a manager in warning mode until they switched back.
  useEffect(() => {
    if (scheduleActualHoursVisible && showWarnings) setShowWarnings(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scheduleActualHoursVisible]);

  const [template_names, set_template_names] = useState([]);
  const [historical_sales_context, set_historical_sales_context] = useState([]);
  const [blackout_dates, set_blackout_dates] = useState([]);
  // Monotonic token used to discard blackout-date responses that resolve after
  // a newer fetch has started (e.g. when the manager switches stores quickly).
  const latestBlackoutDatesFetchTokenRef = React.useRef(0);
  // Always reflects the latest store_id. Used to detect stale closures (e.g. a
  // saveBlackoutDate/deleteBlackoutDate .then callback firing after a store switch)
  // so they don't kick off a fetch for the previous store and interfere with the
  // current store's in-flight request. Initialised from props directly to avoid
  // referencing the local `store_id` const before it's declared lower in the body.
  const latestBlackoutDatesStoreIdRef = React.useRef(props.homeStore);
  const overviewScheduleNavigationTargetRef = React.useRef(
    props.overviewScheduleNavigationTarget
  );
  const overviewScheduleFetchResolvedRef = React.useRef(false);
  const invalidateOverviewCacheProp = props.invalidateOverviewCache;
  const invalidateOverviewCache = React.useCallback(() => {
    if (invalidateOverviewCacheProp) {
      invalidateOverviewCacheProp();
    }
  }, [invalidateOverviewCacheProp]);

  useEffect(() => {
    overviewScheduleNavigationTargetRef.current =
      props.overviewScheduleNavigationTarget;
    overviewScheduleFetchResolvedRef.current = false;
  }, [props.overviewScheduleNavigationTarget]);

  const [load7ShiftsScheduleFinished, setLoad7ShiftsScheduleFinished] =
    React.useState(false);
  const [loadFromTemplateFinished, setLoadFromTemplateFinished] =
    React.useState(false);

  const [schedule_differences, set_schedule_differences] = useState({});
  const [autoScheduleFinished, setAutoScheduleFinished] = useState(false);
  const [autoScheduleError, setAutoScheduleError] = useState(false);
  const [acceptAutoScheduleFinished, setAcceptAutoScheduleFinished] =
    useState(false);

  const [saveShiftFinished, setSaveShiftFinished] = useState(false);

  const [saveAvailabilityFinished, setSaveAvailabilityFinished] =
    useState(false);
  const [publishShiftsFinished, setPublishShiftsFinished] = useState(false);
  const [monthlyCountOfUnpublished, setMonthlyCountOfUnpublished] = useState(0);
  const [monthlyCountOfPublished, setMonthlyCountOfPublished] = useState(0);

  const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  const [lockAllShifts, setLockAllShifts] = useState(false);

  const toggleLockAllShifts = () => {
    setLockAllShifts((prevState) => !prevState);
  };

  const [loading, setLoading] = useState(true);

  const [isCopilotLoading, setIsCopilotLoading] = useState(false);

  const [isAddingAllCopilotShiftsLoading, setIsAddingAllCopilotShiftsLoading] =
    useState(false);

  const [loadedFrom7Shifts, setLoadedFrom7Shifts] = useState(false);
  const [loadedFromTemplate, setLoadedFromTemplate] = useState(false);
  const [loadedFromAuto, setLoadedFromAuto] = useState(false);

  const [addAdjustmentFinished, setAddAdjustmentFinished] = useState(false);

  const [saveEventFinished, setSaveEventFinished] = useState(false);

  const [pushedChanges, setPushedChanges] = useState({
    pushed: false,
    lastPublishedDate: "Nov 2, 2022",
    lastPublishedTime: "10:22pm",
  });

  const [isCopilotOn, setIsCopilotOn] = useState(false);

  // Track which week is selected for copilot in monthly view
  const [selectedWeekForMonthlyCopilot, setSelectedWeekForMonthlyCopilot] = useState(null);
  // Format: Date object representing week start

  const [highlightedEmployees, setHighlightedEmployees] = React.useState(
    new Set()
  );

  const [newScheduleInsights, setNewScheduleInsights] = React.useState(true);

  const [date, setDate] = useState(() =>
    props.scheduleInitialView?.viewMode === "Day"
      ? addDays(week_start_date, props.scheduleInitialView.dowSelected ?? 0)
      : undefined
  );

  const axiosConfig = getDefaultAxiosConfig();

  function formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }

  function addDays(theDate, days) {
    var newDate = new Date(theDate);
    newDate.setDate(theDate.getDate() + days);
    return newDate;
  }

  function increment_day(date, days) {
    const newDate = addDays(date, days);
    setDate(newDate);

    // Calculate new day of week
    let newDow = (dowSelected + days) % 7;
    newDow = newDow < 0 ? 7 + newDow : newDow; // Adjust for negative values

    // Set the day of the week
    setDowSelected((prevDow) => newDow);

    // Calculate potential new week start date
    let potentialWeekStartDate;
    if (newDow === 0) {
      // If the new day is Sunday, then it's the start of a new week
      potentialWeekStartDate = newDate;
    } else {
      // Otherwise, find the start of the week
      potentialWeekStartDate = addDays(newDate, -newDow);
    }

    // Update week start date only if it's different from the current one
    if (!isSameDate(potentialWeekStartDate, week_start_date)) {
      set_week_start_date(potentialWeekStartDate);
    }
  }

  // Helper function to compare dates
  function isSameDate(date1, date2) {
    return (
      date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() === date2.getDate()
    );
  }

  // A profile opened from the schedule hands the view back on return
  // ("Back to schedule"), so Day / Month and the selected day survive the
  // remount.
  const initialView = props.scheduleInitialView || {};
  // The snapshot is only meant for this mount; hand it back so ordinary
  // navigation later doesn't restore an obsolete view.
  React.useEffect(() => {
    if (props.scheduleInitialView) props.onScheduleInitialViewConsumed?.();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const [viewMode, setViewMode] = React.useState(initialView.viewMode || 'Week');
  const [dowSelected, setDowSelected] = React.useState(initialView.dowSelected ?? 0);

  function setView(targetView, d = 0) {
    setViewMode(targetView);
    setDowSelected(d);
    setFiltered("");
    // Turn off copilot when switching views to force refresh
    setIsCopilotOn(false);
    setSelectedWeekForMonthlyCopilot(null);

    if (targetView === 'Day') {
      setSorted("shift_start");
      setShowWarnings(false); // Turn off warnings in daily mode
      const selectedDate = addDays(week_start_date, d);
      setDate(selectedDate);
    } else {
      setSorted("");
    }
  }

  function toggleDailyWeekly(d) {
    // Legacy function for backward compatibility
    const targetView = viewMode === 'Week' ? 'Day' : 'Week';
    setView(targetView, d);
  }

  const [lockedDays, setLockedDays] = React.useState([
    false,
    false,
    false,
    false,
    false,
    false,
    false,
  ]);
  const [lockedPeople, setLockedPeople] = React.useState({});
  function lock_day(dow) {
    let newLockedDays = [...lockedDays];
    let newLockedDaysValue = newLockedDays[dow];
    newLockedDays[dow] = !newLockedDaysValue;
    setLockedDays(newLockedDays);
  }
  function lock_person(id) {
    let newLockedPeople = { ...lockedPeople };
    const newLockedPeopleValue = newLockedPeople[id];
    newLockedPeople[id] = !newLockedPeopleValue;
    setLockedPeople(newLockedPeople);
  }

  const store_id = props.homeStore;
  const [auditRefreshVersion, setAuditRefreshVersion] = useState(0);
  // Unfiltered server data: view/department changes and identical punch
  // refreshes must not invalidate the week's audit.
  const actualPunchesKey = React.useMemo(
    () => JSON.stringify(all_data_full.actual_used_schedule),
    [all_data_full.actual_used_schedule]
  );
  const actualComplianceAudit = useActualComplianceAudit({
    enabled: viewMode !== "Month" && scheduleWeekHasStarted && !!props.laborLawEnabled,
    ready: actualPunchesKey !== undefined,
    storeId: store_id,
    startDate: scheduleWeekStartStr,
    refreshKey: `${auditRefreshVersion}:${actualPunchesKey}`,
  });
  const homeStoreInfo = props.storeNames?.find(
    (store) => Number(store.id) === Number(store_id)
  );
  const homeStoreCompanyName = String(
    homeStoreInfo?.company_info?.company_name || homeStoreInfo?.company_name || ""
  ).trim().toLowerCase();
  const homeStoreName = String(homeStoreInfo?.store_name || "")
    .trim()
    .toLowerCase();
  const fullWeekPastAutoscheduleEnabled =
    homeStoreCompanyName === "test" && homeStoreName === "back bay";
  const permissionOverrides = props.permissionOverrides || [];
  const canPublishSchedule =
    !props.publishScheduleReviewRequiredEnabled ||
    permissionOverrides.includes("publish_schedule_approver") ||
    props.permissionRole === "rightwork_internal";

  function toggleDisplayMode() {
    setDisplayMode((prevState) => !prevState);
  }

  function toggleMinimizeMode() {
    setMinimizeMode((prevState) => !prevState);
  }

  function toggleShowWeeklySummaryCards() {
    setShowWeeklySummaryCards((prevState) => !prevState);
  }

  function filterTeam(value) {
    setFiltered(value);
  }

  function sortTeam(value) {
    setSorted(value);
  }

  function loadTemplateNames() {
    const url = API_get_template_names + store_id;
    axios.get(url, axiosConfig).then((res) => {
      set_template_names(res.data);
    });
  }

  async function saveScheduleAsTemplate(template_name) {
    try {
      // Show loading toast while saving schedule
      toast.loading("Saving Schedule as Template...", { autoClose: false });

      // Update template_name in each element of actual_schedule
      all_data.actual_schedule.forEach((element) => {
        element.template_name = template_name;
        element.template_type = "weekly";
      });

      // Send POST request to save schedule as template
      const axiosConfig = getDefaultAxiosConfig();
      const response = await axios.post(
        API_save_schedule_as_template + store_id,
        all_data.actual_schedule,
        axiosConfig
      );

      // If request is successful, show success toast and perform additional actions
      if (response.status === 201) {
        toast.dismiss();
        toast.success("Schedule Saved as Template!", { autoClose: 3000 });

        // Reload template names after successful save
        loadTemplateNames();
      }
    } catch (error) {
      // Dismiss loading toast on error
      toast.dismiss();

      // Display error message based on response
      if (error.response?.data?.system?.message) {
        toast.error(error.response?.data?.system?.message, { autoClose: 3000 });
      } else {
        toast.error("Request Failed", { autoClose: 3000 });
      }

      console.error("Error:", error); // Handle error as needed
    }
  }

  async function loadEvents() {
    try {
      await fetch_data([API_get_events], ["events"], false);
      setSaveEventFinished(true);
    } catch (error) {
      console.error("Error refreshing schedule events:", error);
    }
  }

  async function saveEvent(event_data, pendingFiles = [], companyId = null) {
    // console.log(event_data);
    event_data["store"] = store_id;
    // Only the note-create POST may reject saveEvent (a genuine save failure).
    const res = await axios.post(API_save_event, event_data, axiosConfig);
    const created = res.data;
    // The note exists now. Upload + attach staged files AFTER creation, and
    // treat any per-file failure as PARTIAL — it must not reject saveEvent, or
    // the UI would mislabel a created note as "failed" and risk a duplicate on
    // retry. Refresh once at the end so the note shows with its attachments.
    let attachmentsFailed = false;
    try {
      if (created?.id && pendingFiles.length > 0 && companyId) {
        for (const file of pendingFiles) {
          let uploadedUuid = null;
          try {
            const payload = await uploadFile(companyId, file, "event");
            uploadedUuid = payload?.uuid || null;
            if (uploadedUuid) {
              await axios.post(
                API_attach_event_file,
                { event_id: created.id, file_upload_uuid: uploadedUuid },
                axiosConfig
              );
            } else {
              attachmentsFailed = true;
            }
          } catch (e) {
            attachmentsFailed = true;
            // Orphan from either a failed attach (uploadedUuid set) or a failed
            // S3 PUT/metadata fetch after the row was created (uuid on the error).
            const orphanUuid = uploadedUuid || e?.fileUploadUuid || null;
            if (orphanUuid) await deleteEventUpload(orphanUuid);
          }
        }
      }
    } finally {
      loadEvents();
    }
    return { event: created, attachmentsFailed };
  }

  function updateEvent(event_id, event_data) {
    return axios
      .patch(API_update_event + event_id, event_data, axiosConfig)
      .then((res) => {
        loadEvents();
        return res.data;
      });
  }

  function deleteEvent(event_id) {
    axios.delete(API_delete_event + event_id, axiosConfig).then(() => {
      loadEvents();
    });
  }

  function attachEventFile(event_id, file_upload_uuid) {
    return axios
      .post(
        API_attach_event_file,
        { event_id, file_upload_uuid },
        axiosConfig
      )
      .then(() => {
        loadEvents();
      });
  }

  function removeEventFile(event_id, file_upload_uuid) {
    return axios
      .post(
        API_remove_event_file,
        { event_id, file_upload_uuid },
        axiosConfig
      )
      .then(() => {
        loadEvents();
      });
  }

  // Best-effort cleanup for a file that uploaded but failed to attach to a note,
  // so a transient attach failure doesn't leave an orphaned TYPE_EVENT upload.
  function deleteEventUpload(file_upload_uuid) {
    return axios
      .post(
        API_delete_file_upload,
        { store_id, file_upload_uuid },
        axiosConfig
      )
      .catch(() => {});
  }

  const eventAttachmentProps = {
    companyId: props.homeCompany,
    attachEventFile,
    removeEventFile,
    deleteEventUpload,
  };

  function loadForecastExcludeDates() {
    return fetch_data(
      [API_get_forecast_exclude_dates],
      ["forecast_exclude_dates"],
      false
    ).catch((error) => {
      console.error("Error refreshing forecast exclude dates:", error);
    });
  }

  function loadHistoricalSalesContext() {
    const url =
      API_get_historical_sales_context +
      store_id +
      "&date=" +
      formatDate(week_start_date?.toString());
    axios.get(url, axiosConfig).then((res) => {
      set_historical_sales_context(res.data);
    });
  }

  function saveForecastExcludeDate(exclude_data) {
    exclude_data["store"] = store_id;
    axios
      .post(API_save_forecast_exclude_date + "?store_id=" + store_id, exclude_data, axiosConfig)
      .then(() => {
        loadForecastExcludeDates();
      });
  }

  function deleteForecastExcludeDate(date_str) {
    axios
      .delete(
        API_delete_forecast_exclude_date + store_id + "&date=" + date_str,
        axiosConfig
      )
      .then(() => {
        loadForecastExcludeDates();
      });
  }

  function loadBlackoutDates() {
    const requestStoreId = store_id;
    // If the closure is stale (e.g. called from an old saveBlackoutDate/
    // deleteBlackoutDate .then after a store switch), skip without advancing
    // the token so we don't drop the current store's in-flight fetch.
    if (latestBlackoutDatesStoreIdRef.current !== requestStoreId) return;
    const token = ++latestBlackoutDatesFetchTokenRef.current;
    const url = API_get_blackout_dates + "?store_id=" + requestStoreId;
    axios.get(url, axiosConfig).then((res) => {
      // Drop the response if a newer fetch has started or the manager has
      // since switched stores — protects against stale data overwriting state.
      if (token !== latestBlackoutDatesFetchTokenRef.current) return;
      if (latestBlackoutDatesStoreIdRef.current !== requestStoreId) return;
      set_blackout_dates(res.data?.redux?.payload?.blackoutDates ?? []);
    });
  }

  function saveBlackoutDate(date_str) {
    return axios
      .post(
        API_create_blackout_date,
        { store_id: store_id, date: date_str, reason: null },
        axiosConfig
      )
      .then(() => {
        loadBlackoutDates();
      });
  }

  function deleteBlackoutDate(date_str) {
    return axios
      .post(
        API_delete_blackout_date,
        { store_id: store_id, date: date_str },
        axiosConfig
      )
      .then(() => {
        loadBlackoutDates();
      });
  }

  function loadFromTemplate(template_name, keep_existing_shifts) {
    setLoadFromTemplateFinished(false);
    const url =
      API_load_schedule_from_template +
      store_id +
      "&date_start=" +
      formatDate(week_start_date?.toString());
    axios
      .put(
        url,
        {
          role_type: roleType,
          template_name: template_name,
          keep_existing_shifts: keep_existing_shifts,
          template_type: "weekly",
        },
        axiosConfig
      )
      .then(() => {
        invalidateOverviewCache();
        setLoadFromTemplateFinished(true);
        refresh_data_in_background(
          actual_schedule_api_calls,
          actual_schedule_set_data_names,
          false
        );
      });
    setLoadedFromTemplate(true);
    setLoadedFrom7Shifts(false);
    setLoadedFromAuto(false);
  }

  // ---- Daily template variants -------------------------------------------
  // Daily templates store/restore the shifts for a single date rather than a
  // whole week. They share the saved_schedule_template table but are isolated
  // by template_type='daily' on the backend.

  async function saveDailyScheduleAsTemplate(template_name, date_str) {
    try {
      toast.loading("Saving Day as Template...", { autoClose: false });

      // Only this day's shifts, stamped as a daily template. Map to fresh
      // objects so we don't mutate the live schedule rows.
      const daily_shifts = all_data.actual_schedule
        .filter((element) => element.date === date_str)
        .map((element) => ({
          ...element,
          template_name: template_name,
          template_type: "daily",
        }));

      const axiosConfig = getDefaultAxiosConfig();
      const response = await axios.post(
        API_save_schedule_as_template + store_id,
        daily_shifts,
        axiosConfig
      );

      if (response.status === 201) {
        toast.dismiss();
        toast.success("Day Saved as Template!", { autoClose: 3000 });
        loadTemplateNames();
      }
    } catch (error) {
      toast.dismiss();
      if (error.response?.data?.system?.message) {
        toast.error(error.response?.data?.system?.message, { autoClose: 3000 });
      } else {
        toast.error("Request Failed", { autoClose: 3000 });
      }
      console.error("Error:", error);
    }
  }

  function loadDailyFromTemplate(template_name, keep_existing_shifts, date_str) {
    setLoadFromTemplateFinished(false);
    // date_start stays the containing week's start so week-level copilot and
    // forecast recompute run for the right week; target_date is the single day
    // the template lands on.
    const url =
      API_load_schedule_from_template +
      store_id +
      "&date_start=" +
      formatDate(week_start_date?.toString());
    axios
      .put(
        url,
        {
          role_type: roleType,
          template_name: template_name,
          keep_existing_shifts: keep_existing_shifts,
          template_type: "daily",
          target_date: date_str,
        },
        axiosConfig
      )
      .then(() => {
        invalidateOverviewCache();
        setLoadFromTemplateFinished(true);
        refresh_data_in_background(
          actual_schedule_api_calls,
          actual_schedule_set_data_names,
          false
        );
      });
    setLoadedFromTemplate(true);
    setLoadedFrom7Shifts(false);
    setLoadedFromAuto(false);
  }

  async function deleteDailyScheduleTemplate(template_name) {
    try {
      toast.loading("Deleting Day Template...", { autoClose: false });
      const url =
        API_delete_schedule_template +
        store_id +
        "&template_name=" +
        template_name +
        "&template_type=daily";
      await axios.delete(url, axiosConfig);
      toast.dismiss();
      toast.success("Day Template Deleted!", { autoClose: 3000 });
      loadTemplateNames();
    } catch (error) {
      toast.dismiss();
      if (error.response?.data?.system?.message) {
        toast.error(error.response?.data?.system?.message, { autoClose: 3000 });
      } else {
        toast.error("Request Failed", { autoClose: 3000 });
      }
      console.error("Error:", error);
    }
  }

  // function deleteScheduleTemplate(template_name) {
  //   const url =
  //     API_delete_schedule_template +
  //     store_id +
  //     "&date_start=" +
  //     formatDate(week_start_date.toString()) +
  //     "&template_name=" +
  //     template_name;
  //   axios.delete(url, axiosConfig).then(() => {
  //     loadTemplateNames();
  //   });
  // }

  async function deleteScheduleTemplate(template_name) {
    try {
      // Show loading toast while deleting schedule template
      toast.loading("Deleting Schedule Template...", { autoClose: false });

      // Construct URL for DELETE request
      const url =
        API_delete_schedule_template +
        store_id +
        "&date_start=" +
        formatDate(week_start_date?.toString()) +
        "&template_name=" +
        template_name;

      // Send DELETE request to delete schedule template
      await axios.delete(url, axiosConfig);

      // If deletion is successful, show success toast and reload template names
      toast.dismiss();
      toast.success("Schedule Template Deleted!", { autoClose: 3000 });
      loadTemplateNames();
    } catch (error) {
      // Dismiss loading toast on error
      toast.dismiss();

      // Display error message based on response
      if (error.response?.data?.system?.message) {
        toast.error(error.response?.data?.system?.message, { autoClose: 3000 });
      } else {
        toast.error("Request Failed", { autoClose: 3000 });
      }

      console.error("Error:", error); // Handle error as needed
    }
  }

  function addShift(shift_info, shift_save_type, appliedTo, outside_of_modal, onComplete, weekStartDateOverride) {
    // Use the override week start date if provided (for monthly view), otherwise use the weekly view's week_start_date
    const effectiveWeekStartDate = weekStartDateOverride || week_start_date;

    let dates_changed = [];
    let todays_date = new Date(new Date().toDateString());
    appliedTo.forEach((d, i) => {
      if (d) {
        let new_date = new Date(addDays(effectiveWeekStartDate, i).toDateString());
        if (new_date >= todays_date) {
          dates_changed.push(formatDate(new_date?.toString()));
        }
      }
    });
    const {
      resolve_open_shift_assignment: assignmentRequested,
      ...shiftPayload
    } = shift_info;
    shiftPayload["dates_changed"] = dates_changed;

    const shouldResolveAssignment = shouldResolveOpenShiftRequest(
      assignmentRequested,
      shift_save_type
    );
    const saveShift = () =>
      shouldResolveAssignment
        ? axios.post(
            API_manager_assign_open_shift,
            {
              store_id,
              actual_schedule_id: shiftPayload.id,
              store_team_member_id: shiftPayload.store_team_member,
              shift: shiftPayload,
            },
            axiosConfig
          )
        : axios.put(
            API_edit_shift +
              store_id +
              "&shift_id=" +
              shiftPayload.id +
              "&action=" +
              shift_save_type +
              "&week_date_start=" +
              formatDate(effectiveWeekStartDate?.toString()),
            shiftPayload,
            axiosConfig
          );

    saveShift()
      .then(() => {
        invalidateOverviewCache();
        refresh_data_in_background(
          SHIFT_MUTATION_REFRESH_API_CALLS,
          SHIFT_MUTATION_REFRESH_DATA_NAMES,
          false
        );
        setSaveShiftFinished(outside_of_modal ? false : true);

        // Call optional callback if provided
        if (onComplete && typeof onComplete === 'function') {
          onComplete();
        }
      })
      .catch((error) => {
        toast.dismiss();
        if (error.response?.data?.system?.message) {
          toast.error(error.response?.data?.system?.message, {
            autoClose: 3000,
          });
        } else {
          toast.error("Request Failed", { autoClose: 3000 });
        }
        console.error("Error in addShift:", error);

        refresh_data_in_background(
          SHIFT_MUTATION_REFRESH_API_CALLS,
          SHIFT_MUTATION_REFRESH_DATA_NAMES,
          false
        );

        setSaveShiftFinished(true);

        // Call optional callback even on error (so UI can update)
        if (onComplete && typeof onComplete === 'function') {
          onComplete();
        }
      });

    setLoadedFrom7Shifts(false);
    setLoadedFromTemplate(false);
    setLoadedFromAuto(false);
  }

  function addMultipleShifts(shifts_info) {
    const affectedEmployees = new Set(
      Object.values(shifts_info)
        .filter((shift) => shift && typeof shift === "object")
        .map((shift) => shift.store_team_member)
    );

    axios
      .put(API_edit_multiple_shifts + store_id, shifts_info, axiosConfig)
      .then(() => {
        invalidateOverviewCache();
        refresh_data_in_background(
          SHIFT_MUTATION_REFRESH_API_CALLS,
          SHIFT_MUTATION_REFRESH_DATA_NAMES,
          false
        );
        setSaveShiftFinished(true);
        setIsAddingAllCopilotShiftsLoading(false);
        if (sorted === "shift_start" && affectedEmployees?.size > 1) {
          setHighlightedEmployees(affectedEmployees);
        }
      })
      .catch((error) => {
        toast.dismiss();
        if (error.response?.data?.system?.message) {
          toast.error(error.response?.data?.system?.message, {
            autoClose: 3000,
          });
        } else {
          toast.error("Request Failed", { autoClose: 3000 });
        }
        console.error("Error in addMultipleShifts:", error);

        refresh_data_in_background(
          SHIFT_MUTATION_REFRESH_API_CALLS,
          SHIFT_MUTATION_REFRESH_DATA_NAMES,
          false
        );

        setSaveShiftFinished(true);
        setIsAddingAllCopilotShiftsLoading(false);
      });

    setLoadedFrom7Shifts(false);
    setLoadedFromTemplate(false);
    setLoadedFromAuto(false);
  }

  function editAvailability(availability_info, appliedTo) {
    let dates_changed = [];
    appliedTo.forEach((d, i) => {
      if (d) {
        let new_date = addDays(week_start_date, i);
        dates_changed.push(formatDate(new_date?.toString()));
      }
    });
    availability_info["dates_changed"] = dates_changed;

    axios
      .put(
        API_edit_availability +
          store_id +
          "&default_checked=" +
          availability_info["default"]?.toString() +
          "&week_date_start=" +
          formatDate(week_start_date?.toString()),
        availability_info,
        axiosConfig
      )
      .then(() => {
        refresh_data_in_background(team_member_api_calls, team_member_set_data_names, false);
        setSaveAvailabilityFinished(true);
      });
  }

  const request_time_off = async (
    title,
    note,
    date_lower_bound,
    date_upper_bound,
    stm_id,
    start_qhnum,
    end_qhnum,
    time_off_type
  ) => {
    // Prepare data to send

    const requestData = {
      store_id: props.homeStore,
      title: title,
      note: note,
      date_lower_bound: date_lower_bound,
      date_upper_bound: date_upper_bound,
      stm_id: stm_id,
    };
    if (start_qhnum !== null && end_qhnum !== null) {
      requestData.start_qhnum = start_qhnum;
      requestData.end_qhnum = end_qhnum;
    }
    if (time_off_type) {
      requestData.time_off_type = time_off_type;
    }

    try {
      toast.loading("Creating Time Off...", { autoClose: false });
      const res = await postRightworkAPI(API_request_time_off, requestData);

      if (res && res.status === 200) {
        toast.dismiss();
        toast.success("Time Off Creation Successful!", { autoClose: 3000 });
        refresh_data_in_background(team_member_api_calls, team_member_set_data_names, false);
      }
    } catch (error) {
      // Handle network error
      if (error.response?.data?.system?.message) {
        toast.dismiss();
        toast.error(error.response?.data?.system?.message, { autoClose: 3000 });
      } else {
        toast.dismiss();
        toast.error("Request Failed");
      }
    }
  };

  function loadFrom7Shifts(weeks_back) {
    setLoad7ShiftsScheduleFinished(false);
    axios
      .put(
        API_load_prev_week_schedule + store_id,
        {
          store_id: store_id,
          date_start: formatDate(week_start_date?.toString()),
          weeks_back: weeks_back,
          role_type: roleType,
        },
        axiosConfig
      )
      .then(() => {
        invalidateOverviewCache();
        setLoad7ShiftsScheduleFinished(true);
        refresh_data_in_background(
          actual_schedule_api_calls,
          actual_schedule_set_data_names,
          true
        );
      });
    setLoadedFromTemplate(false);
    setLoadedFromAuto(false);
  }

  function loadEmployeePreviousSchedule(store_team_member_id) {
    axios
      .put(
        API_load_employee_prev_week_schedule + store_id,
        {
          store_id: store_id,
          store_team_member_id: store_team_member_id,
          date_start: formatDate(week_start_date?.toString()),
        },
        axiosConfig
      )
      .then(() => {
        invalidateOverviewCache();
        refresh_data_in_background(
          actual_schedule_api_calls,
          actual_schedule_set_data_names,
          true
        );
      });
  }

  async function edit_hoo(hoo_info, default_checked) {
    try {
      // Show loading toast while updating hours of operation
      toast.loading("Updating Hours of Operation...", { autoClose: false });

      // Prepare the data
      hoo_info["store"] = store_id;
      const default_param = default_checked ? "default" : "daily";

      // Construct URL for PUT request
      const url =
        API_edit_operating_hours + store_id + "&default_param=" + default_param;

      // Send PUT request to update hours of operation
      await axios.put(url, hoo_info, axiosConfig);

      // If update is successful, show success toast and fetch data
      toast.dismiss();
      toast.success("Hours of Operation Updated!", { autoClose: 3000 });

      // Fetch updated data
      await fetch_data(
        [
          API_get_forecasted_sales_daily,
          API_get_default_operating_hours,
          API_get_daily_operating_hours,
        ],
        [
          "forecasted_sales_daily",
          "default_operating_hours",
          "daily_operating_hours",
        ],
        false
      );
    } catch (error) {
      // Dismiss loading toast on error
      toast.dismiss();

      // Display error message based on response
      if (error.response?.data?.system?.message) {
        toast.error(error.response?.data?.system?.message, { autoClose: 3000 });
      } else {
        toast.error("Failed to Update Hours of Operation", { autoClose: 3000 });
      }

      console.error("Error updating hours of operation:", error);
    }
  }

  async function deleteAllShifts() {
    try {
      // Show loading toast while deleting all shifts
      toast.loading("Deleting All Shifts...", { autoClose: false });

      let locked_people_ids = [];
      all_data.store_team_members.forEach((x) => {
        if (lockedPeople[x.id]) {
          locked_people_ids.push(x.scheduling_app_user_id);
        }
      });

      let newLockedDays = [...lockedDays];
      if (viewMode === 'Day') {
        newLockedDays = newLockedDays.map((value, i) => {
          if (i === dowSelected) {
            return value;
          } else {
            return true;
          }
        });
      }

      const locked_data = {
        locked_days: newLockedDays,
        locked_people: locked_people_ids,
        role_type: roleType,
      };
      const lock_type = lockAllShifts ? "locked" : "unlocked";

      // Construct URL for PUT request
      const url =
        API_delete_all_shifts +
        store_id +
        "&date_start=" +
        formatDate(week_start_date?.toString()) +
        "&date_end=" +
        formatDate(addDays(week_start_date, 6)?.toString()) +
        "&lock_type=" +
        lock_type;

      // Send PUT request to delete all shifts
      await axios.put(url, locked_data, axiosConfig);

      // If deletion is successful, show success toast and fetch data
      toast.dismiss();
      toast.success("All Shifts Deleted!", { autoClose: 3000 });

      invalidateOverviewCache();
      refresh_data_in_background(
        actual_schedule_api_calls,
        actual_schedule_set_data_names,
        false
      );

      setLoadedFrom7Shifts(false);
      setLoadedFromTemplate(false);
      setLoadedFromAuto(false);
    } catch (error) {
      // Dismiss loading toast on error
      toast.dismiss();

      // Display error message based on response
      if (error.response?.data?.system?.message) {
        toast.error(error.response?.data?.system?.message, { autoClose: 3000 });
      } else {
        toast.error("Request Failed", { autoClose: 3000 });
      }

      console.error("Error:", error); // Handle error as needed

      refresh_data_in_background(
        actual_schedule_api_calls,
        actual_schedule_set_data_names,
        false
      );
    }
  }

  function publishShifts(roleTypeFilter) {
    let dateStart, dateEnd;
    if (viewMode === 'Month') {
      dateStart = new Date(currentYear, currentMonth, 1);
      dateEnd = new Date(currentYear, currentMonth + 1, 0);
    } else {
      dateStart = week_start_date;
      dateEnd = addDays(week_start_date, 6);
    }
    const url =
      API_publish_schedule +
      store_id +
      "&date_start=" +
      formatDate(dateStart?.toString()) +
      "&date_end=" +
      formatDate(dateEnd?.toString()) +
      (roleTypeFilter ? "&role_type_filter=" + roleTypeFilter : "");
    axios
      .put(url, {}, axiosConfig)
      .then((response) => {
        invalidateOverviewCache();
        const isReview =
          response?.status === 202 ||
          response?.data?.status === "review_requested";
        const message =
          response?.data?.message ||
          (isReview
            ? "Schedule submitted for review"
            : "Schedule published successfully");
        const toastFn = isReview ? toast.info : toast.success;
        toastFn(message, { autoClose: 3000 });

        refresh_data_in_background(
          [
            API_get_actual_schedule,
            API_get_published_shift_count,
            API_get_published_schedule_actions,
          ],
          [
            "actual_schedule",
            "published_shift_count",
            "published_schedule_actions",
          ],
          false
        );
        setPublishShiftsFinished(true);
        if (props.fetchBadgeCounts) {
          props.fetchBadgeCounts();
        }
      })
      .catch((error) => {
        refresh_data_in_background(
          [
            API_get_actual_schedule,
            API_get_published_shift_count,
            API_get_published_schedule_actions,
          ],
          [
            "actual_schedule",
            "published_shift_count",
            "published_schedule_actions",
          ],
          false
        );
        setPublishShiftsFinished(true);

        const errorMessage =
          error.response?.data?.error ||
          error.response?.data?.system?.message;
        if (errorMessage) {
          toast.error(errorMessage, { autoClose: 3000 });
        } else {
          toast.error("Request Failed", { autoClose: 3000 });
        }
      });
  }

  const handleScheduleReverted = () => {
    invalidateOverviewCache();
    refresh_data_in_background(
      actual_schedule_api_calls,
      actual_schedule_set_data_names,
      false
    );
    if (props.fetchBadgeCounts) {
      props.fetchBadgeCounts();
    }
  };

  function autoSchedule(runType, autoscheduleOptions = {}) {
    // if in daily view mode, lock all except day
    let newLockedDays = [...lockedDays];
    if (viewMode === 'Day') {
      newLockedDays = newLockedDays.map((value, i) => {
        if (i === dowSelected) {
          return value;
        } else {
          return true;
        }
      });
    }

    const locked_data = {
      locked_days: newLockedDays,
      locked_people: lockedPeople,
      autoschedule_options: autoscheduleOptions,
    };
    let lock_type = lockAllShifts ? "locked" : "unlocked";
    if (runType === "autofill") {
      lock_type = "locked";
      runType = "autoschedule";
    }

    const request = axios.put(
      API_auto_schedule +
        store_id +
        "&date_start=" +
        formatDate(week_start_date?.toString()) +
        "&date_end=" +
        formatDate(addDays(week_start_date, 6)?.toString()) +
        "&run_type=" +
        runType +
        "&lock_type=" +
        lock_type,
      locked_data,
      axiosConfig
    );
    return completeAutoschedulePreview(request, {
      onSuccess: (data) => {
        set_schedule_differences(data);
        // Debug stats are supplied only in NON_PROD/LOCAL_DB.
        if (data?.debug_stats) {
          useAutoschedulerDebugStore.getState().setDebugStats(data.debug_stats);
        }
      },
      onError: (message) => {
        setAutoScheduleError(true);
        alert(message);
      },
      onFinished: () => setAutoScheduleFinished(true),
    });
  }

  function acceptNewSchedule(days) {
    const new_schedule = buildAutoscheduleAcceptance(schedule_differences, days);
    axios
      .put(
        API_accept_auto_schedule +
          store_id +
          "&date_start=" +
          formatDate(week_start_date?.toString()) +
          "&date_end=" +
          formatDate(addDays(week_start_date, 6)?.toString()),
        new_schedule,
        axiosConfig
      )
      .then((res) => {
        // console.log("accepted new schedule");
        invalidateOverviewCache();
        refresh_data_in_background(
          actual_schedule_api_calls,
          actual_schedule_set_data_names,
          false
        );
        setAcceptAutoScheduleFinished(true);
      })
      .catch((error) => {
        setAutoScheduleError(true);
        toast.error(error.response?.data?.error || "Unable to save this schedule. Please try again.");
      });
    setLoadedFrom7Shifts(false);
    setLoadedFromTemplate(false);
  }

  function addForecastAdjustment(data, add_type) {
    setAddAdjustmentFinished(false);
    axios
      .put(
        API_add_forecast_adjustment +
          store_id +
          "&date_start=" +
          formatDate(week_start_date?.toString()) +
          "&date_end=" +
          formatDate(addDays(week_start_date, 6)?.toString()) +
          "&add_type=" +
          add_type,
        data,
        axiosConfig
      )
      .then(() => {
        invalidateOverviewCache();
        setAddAdjustmentFinished(true);
        refresh_data_in_background(all_api_calls, all_set_data_names, false);
      });
  }

  function fetchManualIntradayDistribution(dateStr) {
    return axios.get(
      API_get_manual_intraday_distribution +
        store_id +
        "&date=" +
        dateStr,
      axiosConfig
    );
  }

  function saveManualIntradayDistribution(distributionPayload) {
    return axios.put(
      API_save_manual_intraday_distribution + store_id,
      distributionPayload,
      axiosConfig
    ).then(() => {
      invalidateOverviewCache();
      refresh_data_in_background(all_api_calls, all_set_data_names, false);
    });
  }

  function addManualActualSales(data) {
    return axios
      .post(
        API_add_manual_actual_sales + store_id,
        data,
        axiosConfig
      )
      .then(() => {
        // Refresh actual sales data after successful save
        invalidateOverviewCache();
        refresh_data_in_background(all_api_calls, all_set_data_names, false);
      })
      .catch((error) => {
        console.error("Error saving manual actual sales:", error);
        throw error;
      });
  }

  const updatePersonInfo = async (data) => {
    try {
      toast.loading("Updating Employee Attributes...", { autoClose: false });

      const axiosConfig = getDefaultAxiosConfig();
      const res = await axios.put(
        API_update_team_member_info + store_id,
        data,
        axiosConfig
      );

      if (res.status === 200) {
        toast.dismiss();
        toast.success("Employee Attributes Updated!", { autoClose: 3000 });

        try {
          await fetch_data(
            [API_get_store_team_members],
            ["store_team_members"],
            false
          );
        } catch (error) {
          // The PUT completed; a failed GET must not invite a duplicate save.
          toast.warn("Employee attributes saved, but could not refresh. Reload to see the latest values.", { autoClose: 5000 });
          console.error("Error refreshing saved employee attributes:", error);
        }
        return true;
      }
    } catch (error) {
      toast.dismiss();

      if (error.response?.data?.system?.message) {
        toast.error(error.response?.data?.system?.message, { autoClose: 3000 });
        // console.log("ERROR MESSAGE", error.response?.data?.system);
      } else {
        toast.error("Request Failed", { autoClose: 3000 });
      }

      console.error("Error:", error); // Handle error as needed
    }
    return false;
  };

  const post_missed_shift = async (shift_id, missed_shift_reason, options = {}) => {
    // Prepare data to send
    const requestData = {
      store_id: props.homeStore,
      shift_id: shift_id,
      missed_shift_reason: missed_shift_reason,
    };
    if (options.published_schedule_id) {
      requestData.published_schedule_id = options.published_schedule_id;
    }

    try {
      toast.loading("Updating Missed Shift...", { autoClose: false });

      const res = await postRightworkAPI(API_post_missed_shift, requestData);

      if (res.status === 200) {
        toast.dismiss();
        toast.success("Missed Shift Updated", { autoClose: 3000 });

        refresh_data_in_background(
          [
            API_get_actual_schedule,
            API_get_published_shift_count,
            API_get_actual_used_schedule,
          ],
          [
            "actual_schedule",
            "published_shift_count",
            "actual_used_schedule",
          ],
          false
        );
        return res;
      }
    } catch (error) {
      toast.dismiss();

      if (error.response?.data?.system?.message) {
        toast.error(error.response?.data?.system?.message, { autoClose: 3000 });
        // console.log("Error Info", error.response?.data?.system?.data);
      } else {
        toast.error("Request Failed", { autoClose: 3000 });
      }

      console.error("Error:", error); // Handle error as needed
    }

    return null;
  };

  const delete_time_off_request = async (time_off_request_uuid) => {
    // Prepare data to send
    const requestData = {
      store_id: props.homeStore,
      time_off_request_uuid: time_off_request_uuid,
    };

    try {
      toast.loading("Deleting Time Off...", { autoClose: false });

      const res = await postRightworkAPI(
        API_delete_time_off_request,
        requestData
      );

      if (res.status === 200) {
        toast.dismiss();
        toast.success("Time Off Deleted", { autoClose: 3000 });

        refresh_data_in_background(
          [API_get_default_availability, API_get_all_time_off_requests],
          ["default_availability", "all_time_off_requests"],
          false
        );
      }
    } catch (error) {
      toast.dismiss();

      if (error.response?.data?.system?.message) {
        toast.error(error.response?.data?.system?.message, { autoClose: 3000 });
        // console.log("Error Info", error.response?.data?.system?.data);
      } else {
        toast.error("Request Failed", { autoClose: 3000 });
      }

      console.error("Error:", error); // Handle error as needed
    }
  };

  const delete_temporary_availability = async (id) => {
    // Prepare data to send
    const requestData = {
      store_id: props.homeStore,
      id: id,
    };

    try {
      toast.loading("Deleting Temp Availability...", { autoClose: false });

      const res = await postRightworkAPI(
        API_delete_temporary_availability,
        requestData
      );

      if (res.status === 200) {
        toast.dismiss();
        toast.success("Temp Availability Deleted", { autoClose: 3000 });

        refresh_data_in_background(
          [API_get_default_availability, API_get_all_time_off_requests],
          ["default_availability", "all_time_off_requests"],
          false
        );
      }
    } catch (error) {
      toast.dismiss();

      if (error.response?.data?.system?.message) {
        toast.error(error.response?.data?.system?.message, { autoClose: 3000 });
        // console.log("Error Info", error.response?.data?.system?.data);
      } else {
        toast.error("Request Failed", { autoClose: 3000 });
      }

      console.error("Error:", error); // Handle error as needed
    }
  };

  const [copiedShift, setCopiedShift] = useState(null);

  async function get_data(api) {
    // In monthly view, use selected week for copilot APIs, otherwise use current week_start_date
    const isMonthlyView = viewMode === 'Month';
    const isCopilotAPI = api === API_get_copilot_schedule || api === API_get_copilot_status;
    const weekToUse = (isMonthlyView && isCopilotAPI && selectedWeekForMonthlyCopilot)
      ? selectedWeekForMonthlyCopilot
      : week_start_date;


    const isReservationSummaryAPI = api === API_get_reservation_summary;
    // Timecards are filtered server-side on the calendar clock-in date, but a
    // punch belongs to the business day it started. At a store whose day begins
    // after midnight, the week's last business day is still being worked on the
    // next calendar morning, so ask for that day too and let consumers bound by
    // business_date.
    const isActualUsedScheduleAPI = api === API_get_actual_used_schedule;
    const dateStart = isReservationSummaryAPI
      ? addDays(weekToUse, -28) // 4 weeks lookback for same-DOW context in advanced forecasting
      : weekToUse;
    const dateEnd = isReservationSummaryAPI
      ? addDays(weekToUse, 34) // include active week + near-future reservations
      : isActualUsedScheduleAPI
      ? addDays(weekToUse, 7)
      : addDays(weekToUse, 6);

    const url =
      api +
      store_id +
      "&date_start=" +
      formatDate(dateStart?.toString()) +
      "&date_end=" +
      formatDate(dateEnd?.toString()) +
      (isReservationSummaryAPI
        ? "&anchor_date=" + formatDate(new Date().toString())
        : "");
    const res = await axios.get(url, axiosConfig);
    return res;
  }

  const default_api_calls = [
    API_get_forecasted_sales_daily,
    API_get_forecasted_transactions_daily,
    API_get_forecasted_other_daily,
    API_get_adjustments_chosen,
    API_get_adjustments_history,
    API_get_actual_sales_daily,
    API_get_actual_other_daily,
    API_get_calculated_earned_labor,
    API_get_actual_used_labor_vs_earned,
    API_get_store_team_members,
    API_get_default_operating_hours,
    API_get_daily_operating_hours,
    API_get_role_types,
    API_get_weather,
    API_get_events,
    API_get_batch_guidance,
    API_get_actual_intraday_metrics,
    API_get_local_events,
    API_get_forecast_exclude_dates,
    API_get_reservation_summary,
    API_get_spent_labor_daily_summaries,
    API_get_recent_avg_wages,
    API_list_frequent_schedules,
    API_get_grade_weights,
    API_get_actual_used_schedule,
  ];
  const default_set_data_names = [
    "forecasted_sales_daily",
    "forecasted_transactions_daily",
    "forecasted_other_daily",
    "adjustments_chosen",
    "adjustments_history",
    "actual_sales_daily",
    "actual_other_daily",
    "calculated_earned_labor",
    "actual_used_labor_vs_earned",
    "store_team_members",
    "default_operating_hours",
    "daily_operating_hours",
    "role_types",
    "weather",
    "events",
    "batch_guidance",
    "actual_intraday_metrics",
    "local_events",
    "forecast_exclude_dates",
    "reservation_summary",
    "get_spent_labor_daily_summaries",
    "recent_avg_wages",
    "frequent_schedules",
    "grade_weights",
    "actual_used_schedule",
  ];

  const actual_schedule_api_calls = [
    API_get_actual_schedule,
    API_get_copilot_schedule,
    API_get_actual_schedule_labor_deployment,
    API_get_published_shift_count,
    API_get_intraday_metrics,
    API_get_published_schedule_actions,
    API_get_forecasted_labor,
    API_get_surveys_for_date_range,
  ];
  const actual_schedule_set_data_names = [
    "actual_schedule",
    "copilot_schedule",
    "actual_schedule_labor_deployment",
    "published_shift_count",
    "intraday_metrics",
    "published_schedule_actions",
    "forecasted_labor",
    "surveys",
  ];

  const team_member_api_calls = [
    API_get_default_availability,
    API_get_request_off,
    API_get_role_names,
    API_get_all_time_off_requests,
    // API_get_station_info,
  ];
  const team_member_set_data_names = [
    "default_availability",
    "request_off",
    "role_names",
    "all_time_off_requests",
    // "station_info",
  ];

  const data_names_with_role_type = [
    "forecasted_labor",
    "actual_schedule",
    "actual_schedule_labor_deployment",
    "calculated_earned_labor",
    "actual_used_labor_vs_earned",
    "get_spent_labor_daily_summaries",
    "recent_avg_wages",
  ];

  const all_api_calls = default_api_calls.concat(
    actual_schedule_api_calls.concat(team_member_api_calls)
  );
  const all_set_data_names = default_set_data_names.concat(
    actual_schedule_set_data_names.concat(team_member_set_data_names)
  );

  // These responses enrich secondary schedule surfaces, but the core grid can
  // render correctly without waiting for them. Loading them after the critical
  // bundle also keeps them from occupying browser connection slots ahead of
  // shifts, employees, availability, labor, and publication state.
  const critical_initial_api_calls = all_api_calls.filter(
    (_, index) => !DEFERRED_INITIAL_DATA_NAMES.has(all_set_data_names[index])
  );
  const critical_initial_set_data_names = all_set_data_names.filter(
    (data_name) => !DEFERRED_INITIAL_DATA_NAMES.has(data_name)
  );
  const deferred_initial_api_calls = all_api_calls.filter((_, index) =>
    DEFERRED_INITIAL_DATA_NAMES.has(all_set_data_names[index])
  );
  const deferred_initial_set_data_names = all_set_data_names.filter(
    (data_name) => DEFERRED_INITIAL_DATA_NAMES.has(data_name)
  );

  const filter_data_by_role_type = (
    data,
    role_types,
    roleTypeOptions,
    data_names
  ) => {
    var new_data = { ...data };
    if (role_types?.length < roleTypeOptions?.length) {
      data_names?.map((d_name) => {
        if (new_data[d_name]) {
          new_data[d_name] = new_data[d_name]?.filter((d) =>
            role_types?.includes(d.role_type)
          );
        }
      });
    }
    set_all_data(new_data);
  };

  const clearOverviewScheduleNavigationTargetIfCurrent = () => {
    const target = overviewScheduleNavigationTargetRef.current;
    if (!target || !props.setOverviewScheduleNavigationTarget) {
      return;
    }

    if (Number(target.storeId) !== Number(store_id)) {
      return;
    }

    const targetWeekStart = getStartOfCurrentWeek(
      props.businessWeekStartDayIndex,
      target.weekStart
    );
    if (isNaN(targetWeekStart.getTime())) {
      props.setOverviewScheduleNavigationTarget(null);
      return;
    }

    if (!overviewScheduleFetchResolvedRef.current) {
      return;
    }

    if (isSameDate(targetWeekStart, week_start_date)) {
      props.setOverviewScheduleNavigationTarget(null);
    }
  };

  const markOverviewScheduleFetchResolvedIfCurrent = () => {
    const target = overviewScheduleNavigationTargetRef.current;
    if (!target) {
      return;
    }

    if (Number(target.storeId) !== Number(store_id)) {
      return;
    }

    const targetWeekStart = getStartOfCurrentWeek(
      props.businessWeekStartDayIndex,
      target.weekStart
    );
    if (isNaN(targetWeekStart.getTime())) {
      return;
    }
    if (isSameDate(targetWeekStart, week_start_date)) {
      overviewScheduleFetchResolvedRef.current = true;
    }
  };

  const begin_data_requests = (set_data_names) =>
    set_data_names.map((data_name) => {
      const next_generation =
        (dataRequestGenerationRef.current[data_name] || 0) + 1;
      dataRequestGenerationRef.current[data_name] = next_generation;
      return next_generation;
    });

  const merge_api_responses = (
    data,
    responses,
    set_data_names,
    request_generations
  ) => {
    const merged_data = { ...data };
    responses?.forEach((response, index) => {
      const data_name = set_data_names[index];
      if (
        request_generations &&
        dataRequestGenerationRef.current[data_name] !==
          request_generations[index] &&
        Object.prototype.hasOwnProperty.call(merged_data, data_name)
      ) {
        return;
      }
      // A newer request is not yet newer data. Keep an initial fallback when
      // this dataset is absent, in case the newer partial refresh fails.
      merged_data[data_name] = response.data;
    });
    return merged_data;
  };

  const normalize_schedule_response = (data) => {
    const normalized_data = { ...data };
    if (
      normalized_data.actual_schedule?.redux?.payload
        ?.actual_schedule_list !== undefined
    ) {
      normalized_data.labor_law_violations =
        normalized_data.actual_schedule?.redux?.payload?.labor_violations;
      normalized_data.rest_break_regulation =
        normalized_data.actual_schedule?.redux?.payload
          ?.rest_break_regulation;
      normalized_data.meal_break_regulation =
        normalized_data.actual_schedule?.redux?.payload
          ?.meal_break_regulation;
      normalized_data.actual_schedule =
        normalized_data.actual_schedule?.redux?.payload?.actual_schedule_list;
    }
    return normalized_data;
  };

  const apply_fetched_data = (data, sourceStoreId = store_id) => {
    if (Number(sourceStoreId) !== Number(latestScheduleStoreIdRef.current)) {
      return false;
    }

    // Validate before publishing or caching any part of this response.
    const nextRoleFilter = reconcileRoleFilter(data, {
      selected: roleTypeRef.current,
      options: roleTypeOptionsRef.current,
      initialized: roleFilterInitializedRef.current,
      selectAll: roleFilterSelectAllRef.current,
    });
    all_data_full_ref.current = data;
    const renderData = getRenderableScheduleData(data);
    set_all_data_full(renderData);

    const previousStoreScopedData =
      Number(storeScopedInitialDataRef.current.storeId) === Number(sourceStoreId)
        ? storeScopedInitialDataRef.current.data
        : {};
    const nextStoreScopedData = { ...previousStoreScopedData };
    STORE_SCOPED_INITIAL_DATA_NAMES.forEach((dataName) => {
      if (Object.prototype.hasOwnProperty.call(data, dataName)) {
        nextStoreScopedData[dataName] = data[dataName];
      }
    });
    storeScopedInitialDataRef.current = {
      storeId: sourceStoreId,
      data: nextStoreScopedData,
    };

    roleFilterInitializedRef.current = nextRoleFilter.initialized;
    roleFilterSelectAllRef.current = nextRoleFilter.selectAll;
    roleTypeRef.current = nextRoleFilter.selected;
    roleTypeOptionsRef.current = nextRoleFilter.options;
    setRoleType(nextRoleFilter.selected);
    setRoleTypeOptions(nextRoleFilter.options);
    filter_data_by_role_type(
      renderData,
      nextRoleFilter.selected,
      nextRoleFilter.options,
      data_names_with_role_type
    );
    return true;
  };

  const finish_schedule_fetch = () => {
    markOverviewScheduleFetchResolvedIfCurrent();
    setCopilotIsStillCalculating(true);
    setIsCopilotLoading(true);
    setHighlightedEmployees(new Set());
    setNewScheduleInsights(true);
  };

  // options.skipScheduleCompletion: fetch and merge, but leave the schedule
  // completion side effects alone. For refreshes that touch one dataset and
  // have nothing to say about whether the schedule itself changed.
  const fetch_data = async (
    api_calls,
    set_data_names,
    load_screen,
    options = {}
  ) => {
    const requestStoreId = store_id;
    const loadGeneration = scheduleLoadGenerationRef.current;
    const isCurrent = () =>
      scheduleContext === latestScheduleContextRef.current &&
      loadGeneration === scheduleLoadGenerationRef.current;
    if (!isCurrent()) return;
    const request_generations = begin_data_requests(set_data_names);
    try {
      if (load_screen) setLoading(true);
      const responses = await Promise.all(
        api_calls?.map((api) => get_data(api))
      );
      if (!isCurrent()) {
        return;
      }
      const data = normalize_schedule_response(
        merge_api_responses(
          all_data_full_ref.current,
          responses,
          set_data_names,
          request_generations
        )
      );
      if (!apply_fetched_data(data, requestStoreId)) {
        return;
      }
      if (!options.skipScheduleCompletion && !initialScheduleLoadingRef.current) {
        finish_schedule_fetch();
      }
    } finally {
      if (isCurrent() && !initialScheduleLoadingRef.current) {
        setLoading(false);
      }
    }
  };

  const refresh_data_in_background = (...args) => {
    const loadGeneration = scheduleLoadGenerationRef.current;
    fetch_data(...args).catch((error) => {
      if (scheduleContext !== latestScheduleContextRef.current ||
          loadGeneration !== scheduleLoadGenerationRef.current) return;
      console.error("Error refreshing schedule data:", error);
      toast.error("Unable to refresh schedule data. Please try again.", {
        autoClose: 3000,
        toastId: "schedule-refresh-error",
      });
    });
  };

  const fetch_initial_data = async () => {
    const load_generation = scheduleLoadGenerationRef.current + 1;
    scheduleLoadGenerationRef.current = load_generation;
    const cachedStoreScopedData =
      Number(storeScopedInitialDataRef.current.storeId) === Number(store_id)
        ? storeScopedInitialDataRef.current.data
        : {};
    initialScheduleLoadingRef.current = true;
    if (Number(roleFilterStoreRef.current) !== Number(store_id)) {
      roleFilterStoreRef.current = store_id;
      roleFilterInitializedRef.current = false;
      roleFilterSelectAllRef.current = true;
      roleTypeRef.current = [];
      roleTypeOptionsRef.current = [];
      setRoleType([]);
      setRoleTypeOptions([]);
    }
    setLoading(true);
    const initial_schedule_data = {
      store_team_members: [],
      ...cachedStoreScopedData,
    };
    all_data_full_ref.current = initial_schedule_data;
    const initial_render_data = getRenderableScheduleData(initial_schedule_data);
    set_all_data_full(initial_render_data);
    set_all_data(initial_render_data);
    setLockedPeople({});
    set_store_team_member_weekly_info([]);
    set_store_team_member_weekly_info_view([]);

    try {
      const criticalRequestEntries = critical_initial_api_calls
        .map((api, index) => ({
          api,
          dataName: critical_initial_set_data_names[index],
        }))
        .filter(
          ({ dataName }) =>
            !STORE_SCOPED_INITIAL_DATA_NAMES.has(dataName) ||
            !Object.prototype.hasOwnProperty.call(
              cachedStoreScopedData,
              dataName
            )
        );
      const activeCriticalApiCalls = criticalRequestEntries.map(
        ({ api }) => api
      );
      const activeCriticalDataNames = criticalRequestEntries.map(
        ({ dataName }) => dataName
      );
      const critical_request_generations = begin_data_requests(
        activeCriticalDataNames
      );
      const critical_responses = await Promise.all(
        activeCriticalApiCalls.map((api) => get_data(api))
      );
      if (load_generation !== scheduleLoadGenerationRef.current ||
          scheduleContext !== latestScheduleContextRef.current) {
        return;
      }

      const initial_data = {
        ...cachedStoreScopedData,
        ...all_data_full_ref.current,
      };
      Object.entries(DEFERRED_INITIAL_DATA_DEFAULTS).forEach(
        ([data_name, default_value]) => {
          if (!Object.prototype.hasOwnProperty.call(initial_data, data_name)) {
            initial_data[data_name] = Array.isArray(default_value)
              ? []
              : { ...default_value };
          }
        }
      );
      let data = normalize_schedule_response(
        merge_api_responses(
          initial_data,
          critical_responses,
          activeCriticalDataNames,
          critical_request_generations
        )
      );
      if (!apply_fetched_data(data)) return;
      initialScheduleLoadingRef.current = false;
      finish_schedule_fetch();
      setLoading(false);

      const deferred_request_generations = begin_data_requests(
        deferred_initial_set_data_names
      );
      const deferred_results = await Promise.allSettled(
        deferred_initial_api_calls.map((api) => get_data(api))
      );
      if (load_generation !== scheduleLoadGenerationRef.current ||
          scheduleContext !== latestScheduleContextRef.current) {
        return;
      }

      const fulfilled_responses = [];
      const fulfilled_data_names = [];
      const fulfilled_request_generations = [];
      deferred_results.forEach((result, index) => {
        if (result.status === "fulfilled") {
          fulfilled_responses.push(result.value);
          fulfilled_data_names.push(deferred_initial_set_data_names[index]);
          fulfilled_request_generations.push(
            deferred_request_generations[index]
          );
        } else {
          console.error(
            `Deferred schedule request failed: ${deferred_initial_set_data_names[index]}`,
            result.reason
          );
        }
      });
      data = normalize_schedule_response(
        merge_api_responses(
          all_data_full_ref.current,
          fulfilled_responses,
          fulfilled_data_names,
          fulfilled_request_generations
        )
      );
      apply_fetched_data(data);
    } catch (error) {
      if (load_generation === scheduleLoadGenerationRef.current &&
          scheduleContext === latestScheduleContextRef.current) {
        console.error("Error loading critical schedule data:", error);
        toast.error("Unable to load schedule data. Please try again.", {
          autoClose: 3000,
          toastId: "schedule-refresh-error",
        });
      }
    } finally {
      if (load_generation === scheduleLoadGenerationRef.current &&
          scheduleContext === latestScheduleContextRef.current) {
        initialScheduleLoadingRef.current = false;
        setLoading(false);
      }
    }
  };

  const refreshActualsForDate = async () => {
    invalidateOverviewCache();
    await fetch_data(all_api_calls, all_set_data_names, false);
    setAuditRefreshVersion((version) => version + 1);
  };

  // Punches keep landing while the schedule sits open, so switching the metrics
  // toggle to actuals pulls a fresh copy rather than reusing the payload from
  // the week load. Deliberately narrow: refreshActualsForDate refetches every
  // endpoint, which is far too heavy to hang off a toggle.
  //
  // actual_schedule comes along because published shifts carry
  // has_actual_used_schedule, the flag that says whether a shift produced a
  // timecard. Refreshing the punches alone would leave that flag describing an
  // older world, and three separate surfaces read it: the shift card's
  // attendance border, the shift inputs modal, and the monthly view. Fetching
  // both together keeps them consistent by construction rather than asking
  // each reader to second-guess the flag.
  const refreshActualUsedSchedule = async () => {
    await fetch_data(
      [API_get_actual_used_schedule, API_get_actual_schedule],
      ["actual_used_schedule", "actual_schedule"],
      false,
      // Neither says the schedule itself changed. Running the completion
      // handler would put Copilot back into "Updating", restart its polling,
      // and clear highlighted employees, all from flipping a toggle.
      { skipScheduleCompletion: true }
    );
  };

  // Refresh schedule when ops assistant creates/modifies shifts
  const opsScheduleRefreshRef = React.useRef(false);
  useEffect(() => {
    if (!opsScheduleRefreshRef.current) {
      opsScheduleRefreshRef.current = true;
      return;
    }
    if (!props.opsRefreshSignal) return;
    const { types } = props.opsRefreshSignal;
    if (types?.includes("sales")) {
      refresh_data_in_background(all_api_calls, all_set_data_names, false);
    }
    if (types?.includes("schedule")) {
      invalidateOverviewCache();
      refresh_data_in_background(actual_schedule_api_calls, actual_schedule_set_data_names, false);
    }
    if (types?.includes("employees")) {
      // Full refresh — same as what happens on initial load.
      // This ensures store_team_members data is refreshed AND
      // process_data re-runs to update the schedule view + PersonCardModal.
      refresh_data_in_background(all_api_calls, all_set_data_names, false);
    }
    if (types?.includes("time_off") || types?.includes("availability")) {
      // Time-off badges and availability windows both render in the
      // schedule view from the team-member bundle (which carries
      // ``all_time_off_requests`` and ``default_availability``).
      // Single refetch covers both — the schedule bundle (shifts/
      // labor/forecast) is unaffected by these changes.
      refresh_data_in_background(team_member_api_calls, team_member_set_data_names, false);
    }
    if (types?.includes("time_off")) {
      // Blackout dates are a sibling to time-off requests in the
      // domain but live in their own state slice with its own
      // staleness-token-protected loader. The team-member bundle above
      // doesn't include them, so refresh separately when the assistant
      // creates / deletes blackouts (the date cards on the schedule
      // grid render the blackout indicator from this state).
      loadBlackoutDates();
    }
    if (types?.includes("events")) {
      // Day notes created by the assistant (add_day_note) are Event
      // rows; the schedule bundle above doesn't include them.
      loadEvents();
    }
  }, [props.opsRefreshSignal]);

  const fetch_copilot_schedule = async () => {
    const loadGeneration = scheduleLoadGenerationRef.current;
    const data_names = ["copilot_schedule"];
    const request_generations = begin_data_requests(data_names);
    try {
      const res = await get_data(API_get_copilot_schedule);
      if (scheduleContext !== latestScheduleContextRef.current ||
          loadGeneration !== scheduleLoadGenerationRef.current) return;
      const data = merge_api_responses(
        all_data_full_ref.current,
        [res],
        data_names,
        request_generations
      );
      apply_fetched_data(data);
    } catch (error) {
      console.error("Error fetching copilot schedule:", error);
    }
  };

  const fetch_copilot_status = async () => {
    try {
      const res = await get_data(API_get_copilot_status);

      const currentCopilotResult = res.data?.copilot_is_still_calculating;
      setCopilotIsStillCalculating(currentCopilotResult);
    } catch (error) {
      console.error("Error fetching copilot status:", error);
    }
  };

  const [copilotIsStillCalculating, setCopilotIsStillCalculating] =
    React.useState(true);

  // Fetches copilot schedule when copilot task is complete
  useEffect(() => {
    if (!copilotIsStillCalculating && isCopilotLoading) {
      // console.log("fetch_copilot_schedule() because status is complete");
      fetch_copilot_schedule();
      setIsCopilotLoading(false); // Task complete, loading ends
    }
  }, [copilotIsStillCalculating, isCopilotLoading]);

  // Trigger copilot fetch when selected week changes or copilot is toggled on in monthly view
  useEffect(() => {
    if (viewMode === 'Month' && selectedWeekForMonthlyCopilot && isCopilotOn) {
      // Start loading and fetch copilot data for the new week
      setCopilotIsStillCalculating(true);
      setIsCopilotLoading(true);
      fetch_copilot_status();
    }
  }, [selectedWeekForMonthlyCopilot, isCopilotOn, viewMode]);

  // Polls for copilot status every 5 seconds while loading
  useEffect(() => {
    const intervalId = setInterval(() => {
      if (isCopilotOn && isCopilotLoading) {
        // console.log("fetching STATUS because loading");
        fetch_copilot_status();
      }
    }, 2000);

    // Clear interval if copilot loading finishes
    if (!isCopilotLoading) {
      clearInterval(intervalId);
    }

    return () => clearInterval(intervalId);
  }, [isCopilotOn, isCopilotLoading]);

  // Similar to componentDidMount and componentDidUpdate:

  useEffect(() => {
    filter_data_by_role_type(
      all_data_full,
      roleType,
      roleTypeOptions,
      data_names_with_role_type
    );
  }, [roleType]);

  useEffect(() => {
    scheduleLoadGenerationRef.current += 1;
    if (typeof store_id !== "undefined") {
      const overviewScheduleTarget = overviewScheduleNavigationTargetRef.current;
      if (
        overviewScheduleTarget &&
        Number(overviewScheduleTarget.storeId) !== Number(store_id)
      ) {
        setLoading(true);
        return;
      }

      fetch_initial_data();
      setLockedDays([false, false, false, false, false, false, false]);
    }

    return () => {
      scheduleLoadGenerationRef.current += 1;
    };
  }, [week_start_date, store_id]);

  // Clear blackout dates immediately on store switch so the previous store's
  // blocked days aren't visible while the new fetch is in-flight. Bumping the
  // token also invalidates any in-flight response from the previous store, and
  // updating the store-id ref lets stale .then callbacks know to bail out.
  useEffect(() => {
    latestBlackoutDatesStoreIdRef.current = store_id;
    latestBlackoutDatesFetchTokenRef.current += 1;
    set_blackout_dates([]);
  }, [store_id]);

  useEffect(() => {
    if (typeof store_id !== "undefined") {
      loadTemplateNames();
      loadBlackoutDates();
    }
  }, [store_id]);

  useEffect(() => {
    if (typeof store_id !== "undefined") {
      loadHistoricalSalesContext();
    }
  }, [store_id, week_start_date]);

  function increment_week(start_date, add_week) {
    const new_start_date = addDays(start_date, add_week * 7);
    set_week_start_date(new_start_date);
  }

  function increment_month(direction) {
    if (direction === 1) {
      if (currentMonth === 11) {
        setCurrentMonth(0);
        setCurrentYear(currentYear + 1);
      } else {
        setCurrentMonth(currentMonth + 1);
      }
    } else if (direction === -1) {
      if (currentMonth === 0) {
        setCurrentMonth(11);
        setCurrentYear(currentYear - 1);
      } else {
        setCurrentMonth(currentMonth - 1);
      }
    }
  }

  const scheduled_hours = all_data.actual_schedule_labor_deployment;
  const [store_team_member_weekly_info, set_store_team_member_weekly_info] =
    React.useState([]);
  const [
    store_team_member_weekly_info_view,
    set_store_team_member_weekly_info_view,
  ] = React.useState([]);

  function agg_column(df, column) {
    return df?.reduce(function (a, b) {
      return a + b[column];
    }, 0);
  }

  function filter_df_to_day(df, column, date_str) {
    return df?.filter((s) => s[column] === date_str);
  }

  function checkTimeOffConflictWithQH(shift, timeOffRequests) {
    if (!timeOffRequests || timeOffRequests.length === 0) {
      return false;
    }

    // Check each time off request for overlap with the shift
    return timeOffRequests.some(request => {
      // If the request doesn't have start_qhnum or end_qhnum, fall back to full-day conflict
      if (request.start_qhnum === null || request.end_qhnum === null) {
        return true; // Treat as full day conflict
      }

      const timeOffStart = request.start_qhnum;
      const timeOffEnd = request.end_qhnum;
      const shiftStart = shift.shift_start;
      const shiftEnd = shift.shift_end;

      // Check if there's any overlap between shift and time off
      // Overlap exists if: shift_start < timeoff_end AND shift_end > timeoff_start
      return shiftStart < timeOffEnd && shiftEnd > timeOffStart;
    });
  }

  function countConflicts(shift, avail, timeoff) {
    const details = [];

    if (shift.length > 0) {
      // Check for time-off conflicts using the new partial time-off logic
      if (timeoff.length > 0) {
        const hasTimeOffConflict = checkTimeOffConflictWithQH(shift[0], timeoff);
        if (hasTimeOffConflict) {
          details.push({ shift: shift[0], reason: "Time off" });
        }
      } else if (avail.length > 0) {
        // Existing availability conflict logic remains the same
        const {
          available_from,
          available_to,
          available_from_2,
          available_to_2,
        } = avail[0];

        // If the shift falls outside both availability ranges
        const outsideRange1 =
          available_from !== 0 || available_to !== 24
            ? available_from > shift[0].shift_start ||
              available_to < shift[0].shift_end
            : false;
        const outsideRange2 =
          available_from_2 !== undefined && available_to_2 !== undefined // Ensure availability_2 exists
            ? available_from_2 > shift[0].shift_start ||
              available_to_2 < shift[0].shift_end
            : false;

        // Record conflict if shift is outside both ranges
        if (outsideRange1 && outsideRange2) {
          details.push({ shift: shift[0], reason: "Outside availability" });
        }
      }
    }

    return details;
  }

  function process_data(isCopilotOn) {
    if (all_data.store_team_members.length > 0) {
      // Filter store team members based on status and shifts
      const filteredStoreTeamMembers = all_data.store_team_members.filter((member) => {
        // Always show active members
        if (member.status === "active") {
          return true;
        }

        // For archived or hidden members, only show if they have shifts
        if (member.status === "archived" || member.status === "hidden") {
          const hasShifts = all_data.actual_schedule.some(
            (shift) => shift.store_team_member === member.id
          );
          return hasShifts;
        }

        // Default: show the member (in case there are other status values)
        return true;
      });

      // aggregate weekly hours by person
      let weekly_hours_by_person = all_data.actual_schedule.reduce(function (
        res,
        value
      ) {
        if (!res[value.user_id]) {
          res[value.user_id] = 0;
        }
        res[value.user_id] += value.hours;
        return res;
      },
      {});

      // aggregate weekly hours by person
      let weekly_other_store_hours_by_person = all_data.actual_schedule
        .filter((v, i) => v.other_store === true)
        .reduce(function (res, value) {
          if (!res[value.user_id]) {
            res[value.user_id] = 0;
          }
          res[value.user_id] += value.hours;
          return res;
        }, {});

      let lockedTeamDict = {};
      // add total weekly hours to store_team_member - using filtered list
      var store_team_member_weekly_info = filteredStoreTeamMembers?.map(
        (x) => {
          x.hours = weekly_hours_by_person[x.user?.id]
            ? weekly_hours_by_person[x.user?.id]
            : 0;
          x.other_store_hours = weekly_other_store_hours_by_person[x.user?.id]
            ? weekly_other_store_hours_by_person[x.user?.id]
            : 0;
          x.min_weekly_hours = x.min_weekly_hours ?? 0;
          x.target_weekly_hours = x.target_weekly_hours ?? 0;
          x.max_weekly_hours = x.max_weekly_hours ?? 0;
          if (all_data.default_availability.length > 0) {
            const available_hours_default = all_data.default_availability
              .filter((p) => p.store_team_member === x.id)
              .map((d) => {
                d.duration = d.available_to - d.available_from;
                return d;
              });
            x.default_available_hours = agg_column(
              available_hours_default,
              "duration"
            );
          } else {
            x.default_available_hours = 0;
          }
          x.total_available_hours = x.default_available_hours;
          x.available_role_info = x.roles_and_role_types || [];
          let main_role_name = ""; //all_data.role_names[0]["role_name"];
          let role_type = ""; //all_data.role_names[0]["role_type"];
          let main_role_id = null; //all_data.role_names[0]["id"];
          const overtime_hours_threshold = 40;
          const mainRole = getEmployeeMainRole(x.available_role_info);
          if (mainRole) {
            const roleNameInfo = all_data.role_names.find(
              (r) => r.id === mainRole.scheduled_role
            );
            if (roleNameInfo) {
              main_role_name = roleNameInfo.role_name;
              main_role_id = roleNameInfo.id;
            }
            role_type = getRoleType(
              mainRole.scheduled_role,
              all_data.role_names
            );
          }
          x.role = main_role_name;
          x.role_type = role_type;
          x.main_role_id = main_role_id;
          const scheduleRoles = getEmployeeRolesInDepartments(
            x,
            roleType,
            all_data.role_names,
            roleType.length < roleTypeOptions.length
          );
          const defaultScheduleRole = getDefaultScheduleRole(x, scheduleRoles);
          x.schedule_available_role_info = scheduleRoles;
          x.schedule_default_role_id =
            defaultScheduleRole?.scheduled_role ?? null;
          x.schedule_default_role_type = defaultScheduleRole
            ? getRoleType(defaultScheduleRole.scheduled_role, all_data.role_names)
            : null;
          x.overtime_hours_threshold = overtime_hours_threshold;
          x.countOfConflicts = 0;
          x.dailyConflicts = [0, 0, 0, 0, 0, 0, 0];
          x.dailyConflictDetails = [[], [], [], [], [], [], []];
          x.overtimeFlag = 0;
          const person_time_off_requests =
            all_data.all_time_off_requests.filter(
              (p) => p.store_team_member === x.id
            );
          [0, 1, 2, 3, 4, 5, 6].map((dow) => {
            const date = addDays(week_start_date, dow);
            const date_str = formatDate(date);
            const shift = filter_df_to_day(
              isCopilotOn
                ? all_data.copilot_schedule
                : all_data.actual_schedule,
              "date",
              date_str
            ).filter((s) => s.store_team_member === x.id);
            const other_store_shift = filter_df_to_day(
              all_data.actual_schedule,
              "date",
              date_str
            ).filter(
              (s) => (s.user_id === x.user?.id) & (s.other_store === true)
            );
            // Get the day of week for week_start_date (0 for Sunday, 1 for Monday, etc.)
            const startDayOfWeek = props.businessWeekStartDayIndex;

            // Calculate the adjusted day of the week for default_availability
            let adjustedDow;
            if (startDayOfWeek === 0) {
              // If the week starts on Sunday
              adjustedDow = dow === 0 ? 7 : dow;
            } else {
              // For any other day
              adjustedDow = (dow + startDayOfWeek) % 7;
              adjustedDow = adjustedDow === 0 ? 7 : adjustedDow; // Adjust for Sunday
            }

            let default_availability = filter_df_to_day(
              all_data.default_availability,
              "dow",
              adjustedDow
            ).filter((s) => s.store_team_member === x.id);

            let dow_avail = default_availability;

            let timeoff = person_time_off_requests.filter((request) => {
              // If date_upper_bound is null, then check if date_lower_bound matches the specific date
              if (!request.date_upper_bound) {
                return request.date_lower_bound === date_str;
              }

              // If date_upper_bound is not null, then check if specific date is within the range of date_lower_bound to date_upper_bound
              return (
                request.date_lower_bound <= date_str &&
                request.date_upper_bound >= date_str
              );
            });

            x[dow] = shift;
            x[dow + "_other_store_shift"] = other_store_shift;
            x[dow + "_availability"] = dow_avail;
            x[dow + "_timeoff"] = timeoff;
            const dayConflictDetails = countConflicts(shift, dow_avail, timeoff);
            x.countOfConflicts += dayConflictDetails.length;
            x.dailyConflicts[dow] += dayConflictDetails.length;
            const fullName =
              formatName(
                `${x.first_name || ""} ${x.last_name || ""}`.trim()
              ) || "Unknown";
            dayConflictDetails.forEach((d) => {
              x.dailyConflictDetails[dow].push({
                ...d,
                employeeName: fullName,
              });
            });
          });
          x.overtimeFlag =
            !props.laborLawEnabled && x.hours > x.overtime_hours_threshold ? 1 : 0;
          x.complianceViolationsFlag =
            laborLawViolations?.filter((p) => p.store_team_member_id === x.id)
              ?.length > 0
              ? 1
              : 0;

          if (x.id in lockedPeople) {
            lockedTeamDict[x.id] = lockedPeople[x.id];
          } else {
            lockedTeamDict[x.id] = false;
          }
          return x;
        }
      );

      let new_view = filter_data(
        filtered,
        searchInput,
        store_team_member_weekly_info,
        selectedRolesForFiltering
      );
      if (roleType.length < roleTypeOptions.length) {
        // The department filter reads an employee's own role assignments, so
        // it asks who works in the department rather than which work was done
        // there. Actual mode does not change that: somebody who has moved
        // departments since is no longer one of its people, and their hours
        // are a filter away rather than under a heading naming a department
        // they left. Both modes answer the same question.
        new_view = new_view.filter((employee) =>
          employeeHasRoleInDepartments(employee, roleType, all_data.role_names)
        );
      }

      setLockedPeople(lockedTeamDict);
      set_store_team_member_weekly_info(store_team_member_weekly_info);
      if (showWarnings) {
        const grouped_data = group_by_conflicts(new_view);
        set_store_team_member_weekly_info_view(grouped_data);
      } else {
        const sorted_data = sort_data(sorted, new_view, dowSelected);
        let final_data = sorted_data;
        if (segmentMode === "role" || segmentMode === "department") {
          final_data = group_by_role(sorted_data, segmentMode);
        }
        set_store_team_member_weekly_info_view(final_data);
      }
      clearOverviewScheduleNavigationTargetIfCurrent();
    } else {
      setLockedPeople({});
      set_store_team_member_weekly_info([]);
      set_store_team_member_weekly_info_view([]);
      clearOverviewScheduleNavigationTargetIfCurrent();
    }
  }

  function filter_data(
    filtered,
    searchInput,
    old_data,
    selectedRolesForFiltering = []
  ) {
    const searchTerm = searchInput.toLowerCase();
    const filterArray = Array.isArray(filtered)
      ? filtered
      : filtered
      ? [filtered]
      : [];
    const hasTopFilters = filterArray.length > 0;
    const hasRoleFilters = selectedRolesForFiltering.length > 0;

    let filteredData = [...old_data];

    // Apply top-level filters (AND-chained)
    filterArray.forEach((f) => {
      if (f === "Scheduled Only") {
        filteredData = filteredData.filter((d) => d.hours > 0);
      } else if (f === "has_shift") {
        filteredData = filteredData.filter((d) => d[dowSelected].length > 0);
      } else if (f === "Availability Conflicts") {
        filteredData = filteredData.filter((d) => (d.countOfConflicts || 0) > 0);
      } else if (f === "Schedule Violations") {
        filteredData = filteredData.filter((d) =>
          props.laborLawEnabled
            ? (d.complianceViolationsFlag || 0) > 0
            : (d.overtimeFlag || 0) > 0
        );
      } else if (f === "Has Availability") {
        filteredData = filteredData.filter((d) => d.total_available_hours > 0);
      }
    });

    // Apply role filtering
    if (hasRoleFilters) {
      filteredData = filteredData.filter((d) =>
        selectedRolesForFiltering.includes(d.main_role_id)
      );
    }

    // Apply name search
    const searchedData = filteredData.filter((d) => {
      const full_name = `${d.first_name} ${d.last_name}`.toLowerCase();
      return full_name.includes(searchTerm);
    });

    if (searchedData.length > 0) {
      setNoMatchingSearch(false);
      return searchedData;
    } else {
      setNoMatchingSearch(true);
      // On search miss: preserve filter state; only fall back to all data when nothing is filtered
      return hasTopFilters || hasRoleFilters ? filteredData : [...old_data];
    }
  }

  function sort_data(sorted, old_data, dow) {
    const data = [...old_data];
    if (sorted === "warnings") {
      return data.sort((a, b) => {
        const aWarnings = props.laborLawEnabled
          ? (a.complianceViolationsFlag || 0) * 5 + (a.countOfConflicts || 0)
          : (a.overtimeFlag || 0) * 5 + (a.countOfConflicts || 0);
        const bWarnings = props.laborLawEnabled
          ? (b.complianceViolationsFlag || 0) * 5 + (b.countOfConflicts || 0)
          : (b.overtimeFlag || 0) * 5 + (b.countOfConflicts || 0);

        if (aWarnings > bWarnings) {
          return -1;
        } else if (bWarnings > aWarnings) {
          return 1;
        } else {
          // When warnings are equal, sort by first_name
          return a.first_name?.localeCompare(b.first_name);
        }
      });
    } else if (sorted === "") {
      return data.sort((a, b) => {
        // First, compare by sort_index
        if (a.sort_index < b.sort_index) return -1;
        if (a.sort_index > b.sort_index) return 1;

        // If sort_index is equal, then compare by role_type
        let dept_a = a.primary_role_type_name ? a.primary_role_type_name : "ZZ";
        let dept_b = b.primary_role_type_name ? b.primary_role_type_name : "ZZ";
        if (dept_a < dept_b) return -1;
        if (dept_a > dept_b) return 1;

        let role_a = a.role === "" ? "ZZ" : a.role;
        let role_b = b.role === "" ? "ZZ" : b.role;
        if (role_a < role_b) return -1;
        if (role_a > role_b) return 1;

        // If role_type is also equal, finally compare by first_name
        return a.last_name?.localeCompare(b.last_name);
      });
    } else if (sorted === "availability") {
      return data.sort((a, b) =>
        a.total_available_hours < b.total_available_hours
          ? 1
          : b.total_available_hours < a.total_available_hours
          ? -1
          : 0
      );
    } else if (sorted === "department") {
      return data.sort((a, b) => {
        // If sort_index is equal, then compare by role_type
        let dept_a = a.primary_role_type_name ? a.primary_role_type_name : "ZZ";
        let dept_b = b.primary_role_type_name ? b.primary_role_type_name : "ZZ";
        if (dept_a < dept_b) return -1;
        if (dept_a > dept_b) return 1;
        return a.first_name?.localeCompare(b.first_name);
      });
    } else if (sorted === "first") {
      return data.sort((a, b) => a.first_name?.localeCompare(b.first_name));
    } else if (sorted === "last") {
      return data.sort((a, b) => a.last_name?.localeCompare(b.last_name));
    } else if (sorted === "shift_start") {
      return data.sort((a, b) =>
        a[dow].length > 0
          ? b[dow].length > 0
            ? a[dow][0].shift_start < b[dow][0].shift_start
              ? -1
              : a[dow][0].shift_start > b[dow][0].shift_start
              ? 1
              : a[dow][0].shift_end < b[dow][0].shift_end
              ? -1
              : a[dow][0].shift_end > b[dow][0].shift_end
              ? 1
              : 0
            : -1
          : 1
      );
    } else if (sorted === "role") {
      const roleIdToSortIndex = {};
      (all_data.role_names || []).forEach((r) => {
        roleIdToSortIndex[r.id] = r.sort_index;
      });
      return data.sort((a, b) => {
        const aIdx = roleIdToSortIndex[a.main_role_id];
        const bIdx = roleIdToSortIndex[b.main_role_id];
        const aHas = aIdx !== null && aIdx !== undefined;
        const bHas = bIdx !== null && bIdx !== undefined;
        if (aHas && bHas && aIdx !== bIdx) return aIdx - bIdx;
        if (aHas && !bHas) return -1;
        if (!aHas && bHas) return 1;
        const nameCmp = (a.role || "").localeCompare(b.role || "");
        if (nameCmp !== 0) return nameCmp;
        return (a.first_name || "").localeCompare(b.first_name || "");
      });
    } else {
      return data.sort((a, b) =>
        a[sorted] < b[sorted] ? 1 : b[sorted] < a[sorted] ? -1 : 0
      );
    }
  }

  function group_by_role(data, groupByField) {
    if (!data || data.length === 0) return [];

    // Determine the field to group by
    const fieldName = groupByField === "department" ? "primary_role_type_name" : "role";

    // Group employees by the specified field
    const grouped = {};
    data.forEach((employee) => {
      const groupValue = employee[fieldName] || "Unassigned";
      if (!grouped[groupValue]) {
        grouped[groupValue] = [];
      }
      grouped[groupValue].push(employee);
    });

    const roleNameToMinSortIndex = {};
    if (groupByField === "role") {
      (all_data.role_names || []).forEach((r) => {
        const idx = r.sort_index;
        if (idx === null || idx === undefined) return;
        const current = roleNameToMinSortIndex[r.role_name];
        if (current === undefined || idx < current) {
          roleNameToMinSortIndex[r.role_name] = idx;
        }
      });
    }

    const sortedGroupNames = Object.keys(grouped).sort((aKey, bKey) => {
      if (groupByField === "role") {
        const aIdx = roleNameToMinSortIndex[aKey];
        const bIdx = roleNameToMinSortIndex[bKey];
        const aHas = aIdx !== undefined;
        const bHas = bIdx !== undefined;
        if (aHas && bHas && aIdx !== bIdx) return aIdx - bIdx;
        if (aHas && !bHas) return -1;
        if (!aHas && bHas) return 1;
      }
      return aKey.localeCompare(bKey);
    });

    // Convert to array with headers
    const result = [];
    sortedGroupNames.forEach((groupName) => {
      // Add group header
      result.push({
        isRoleHeader: true,
        roleName: groupName,
        id: `header-${groupName}`,
      });
      // Add employees for this group
      result.push(...grouped[groupName]);
    });

    return result;
  }

  function group_by_conflicts(data) {
    if (!data || data.length === 0) return [];

    // Separate into conflicted and non-conflicted employees
    const conflicted = [];
    const nonConflicted = [];

    data.forEach((employee) => {
      const warnings = props.laborLawEnabled
        ? (employee.complianceViolationsFlag || 0) * 5 + (employee.countOfConflicts || 0)
        : (employee.overtimeFlag || 0) * 5 + (employee.countOfConflicts || 0);

      if (warnings > 0) {
        conflicted.push({ ...employee, _warningCount: warnings });
      } else {
        nonConflicted.push(employee);
      }
    });

    // Sort conflicted employees by severity (descending)
    conflicted.sort((a, b) => {
      if (a._warningCount > b._warningCount) return -1;
      if (b._warningCount > a._warningCount) return 1;
      return a.first_name?.localeCompare(b.first_name);
    });

    // Build result with headers
    const result = [];

    if (conflicted.length > 0) {
      result.push({
        isRoleHeader: true,
        roleName: "Warnings",
        id: "header-conflicted",
      });
      result.push(...conflicted);
    }

    if (nonConflicted.length > 0) {
      result.push({
        isRoleHeader: true,
        roleName: "No Warnings",
        id: "header-non-conflicted",
      });
      result.push(...nonConflicted);
    }

    return result;
  }

  function toggleReorderMode() {
    if (!reorderMode) {
      // Reordering edits the default order, so drop any active sort/grouping
      setSorted("");
      setSegmentMode("default");
    }
    setReorderMode(!reorderMode);
  }

  async function persistTeamMemberOrder(orderPayload) {
    try {
      await postRightworkAPI(API_store_team_member_set_order, {
        store_id: store_id,
        store_team_member_settings: JSON.stringify(orderPayload),
      });
    } catch (error) {
      toast.error("Failed to save the new order", { autoClose: 3000 });
      console.error("Error:", error);
    }
  }

  function reorderTeamMembers(sourceIndex, destinationIndex) {
    const currentView = store_team_member_weekly_info_view || [];
    if (sourceIndex === destinationIndex) return;
    if (currentView.some((item) => item.isRoleHeader)) return;

    const reorderedView = Array.from(currentView);
    const [movedPerson] = reorderedView.splice(sourceIndex, 1);
    reorderedView.splice(destinationIndex, 0, movedPerson);

    // The view can be a filtered subset, so merge its new order back into the
    // full roster; the stable sort keeps the backend tie-break order for
    // members that have never been assigned a sort_index
    const fullRoster = [...(all_data.store_team_members || [])].sort((a, b) => {
      const aIdx = a.sort_index ?? Number.MAX_SAFE_INTEGER;
      const bIdx = b.sort_index ?? Number.MAX_SAFE_INTEGER;
      return aIdx - bIdx;
    });
    const viewIds = new Set(reorderedView.map((person) => person.id));
    const reorderedQueue = [...reorderedView];
    const mergedRoster = fullRoster.map((person) =>
      viewIds.has(person.id) ? reorderedQueue.shift() : person
    );

    // weekly_info rows share references with all_data.store_team_members, so
    // updating sort_index in place keeps every later re-sort in the new order
    mergedRoster.forEach((person, index) => {
      person.sort_index = index;
    });

    set_store_team_member_weekly_info_view(reorderedView);
    // Archived members can appear on the schedule (old shifts) but are hidden
    // from the backend's default STM manager, which 500s the endpoint's auth
    // lookup when one is first in the payload, so leave them out entirely
    const orderPayload = mergedRoster
      .filter((person) => person.status !== "archived")
      .map((person) => ({
        id: person.id,
        sort_index: person.sort_index,
      }));
    if (orderPayload.length > 0) {
      persistTeamMemberOrder(orderPayload);
    }
  }

  // Reordering only makes sense in the default view; leave the mode if the
  // user switches to a sort, grouping, or the warnings view
  useEffect(() => {
    if (
      reorderMode &&
      (sorted !== "" || segmentMode !== "default" || showWarnings)
    ) {
      setReorderMode(false);
    }
  }, [reorderMode, sorted, segmentMode, showWarnings]);

  useEffect(() => {
    const new_data = filter_data(
      filtered,
      searchInput,
      store_team_member_weekly_info,
      selectedRolesForFiltering
    );
    const sorted_data = sort_data(sorted, new_data, dowSelected);
    const final_data = (!showWarnings && (segmentMode === "role" || segmentMode === "department")) ? group_by_role(sorted_data, segmentMode) : sorted_data;
    set_store_team_member_weekly_info_view(final_data);
  }, [filtered, searchInput, selectedRolesForFiltering]);

  useEffect(() => {
    const new_data = sort_data(
      sorted,
      store_team_member_weekly_info_view.filter(item => !item.isRoleHeader),
      dowSelected
    );
    const final_data = (!showWarnings && (segmentMode === "role" || segmentMode === "department")) ? group_by_role(new_data, segmentMode) : new_data;
    set_store_team_member_weekly_info_view(final_data);
  }, [sorted, dowSelected]);

  useEffect(() => {
    if (showWarnings) {
      const employees = store_team_member_weekly_info_view.filter(item => !item.isRoleHeader);
      const grouped_data = group_by_conflicts(employees);
      set_store_team_member_weekly_info_view(grouped_data);
    } else {
      const sorted_data = sort_data(sorted, store_team_member_weekly_info_view.filter(item => !item.isRoleHeader), dowSelected);
      const final_data = (segmentMode === "role" || segmentMode === "department") ? group_by_role(sorted_data, segmentMode) : sorted_data;
      set_store_team_member_weekly_info_view(final_data);
    }
  }, [showWarnings, dowSelected]);

  useEffect(() => {
    const employees = store_team_member_weekly_info_view.filter(item => !item.isRoleHeader);
    let final_data = employees;
    if (!showWarnings) {
      if (segmentMode === "role" || segmentMode === "department") {
        final_data = group_by_role(employees, segmentMode);
      } else {
        // When switching back to default, re-apply the current sort (which uses sort_index as primary)
        final_data = sort_data(sorted, employees, dowSelected);
      }
    }
    set_store_team_member_weekly_info_view(final_data);
  }, [segmentMode]);

  // Save segmentMode to localStorage
  useEffect(() => {
    localStorage.setItem('rightwork_segmentMode', segmentMode);
  }, [segmentMode]);

  // Save minimizeMode to localStorage
  useEffect(() => {
    localStorage.setItem('rightwork_minimizeMode', minimizeMode);
  }, [minimizeMode]);

  // Save showWeeklySummaryCards to localStorage
  useEffect(() => {
    localStorage.setItem('rightwork_showWeeklySummaryCards', showWeeklySummaryCards);
  }, [showWeeklySummaryCards]);

  // Recalculate week_start_date when businessWeekStartDayIndex changes to align with new week boundaries
  useEffect(() => {
    if (week_start_date && props.businessWeekStartDayIndex !== undefined) {
      // Calculate what the week start should be for the current week_start_date with the new businessWeekStartDayIndex
      const alignedWeekStart = getStartOfCurrentWeek(
        props.businessWeekStartDayIndex,
        week_start_date
      );

      // Only update if the aligned week start is different from current week_start_date
      if (alignedWeekStart.getTime() !== week_start_date.getTime()) {
        set_week_start_date(alignedWeekStart);
      }
    }
  }, [props.businessWeekStartDayIndex]);

  // When scheduleRenderDate is set (e.g. from Overview click), consume it once and clear
  useEffect(() => {
    if (props.scheduleRenderDate) {
      const alignedDate = getStartOfCurrentWeek(
        props.businessWeekStartDayIndex,
        props.scheduleRenderDate
      );
      if (!isNaN(alignedDate.getTime())) {
        set_week_start_date(alignedDate);
      }
      // Clear the consumed date so it doesn't reapply on future mounts
      if (props.setScheduleRenderDate) {
        props.setScheduleRenderDate(undefined);
      }
    }
  }, [props.scheduleRenderDate, props.businessWeekStartDayIndex]);

  // Save selected week to localStorage and notify parent
  useEffect(() => {
    if (week_start_date) {
      localStorage.setItem('rightwork_selectedWeekStart', week_start_date.toISOString());
      props.onScheduleWeekChange?.({
        start: formatDate(week_start_date.toString()),
        end: formatDate(addDays(week_start_date, 6).toString()),
      });
    }
  }, [week_start_date]);

  useEffect(() => {
    process_data(isCopilotOn);
  }, [all_data, isCopilotOn]);

  function checkIfForecastAvail() {
    try {
      return all_data.forecasted_labor.length > 0;
    } catch (error) {
      return false;
    }
  }

  function countWarnings() {
    let countConflicts = 0;
    let countOvertime = 0;
    const dailyConflicts = [0, 0, 0, 0, 0, 0, 0];
    const dailyConflictDetails = [[], [], [], [], [], [], []];
    if (all_data.store_team_members.length > 0) {
      store_team_member_weekly_info.map((value, index) => {
        countOvertime += value.overtimeFlag || 0;
        countConflicts += value.countOfConflicts || 0;
        const stmDaily = value.dailyConflicts || [];
        const stmDetails = value.dailyConflictDetails || [];
        for (let i = 0; i < 7; i++) {
          dailyConflicts[i] += stmDaily[i] || 0;
          if (Array.isArray(stmDetails[i])) {
            dailyConflictDetails[i].push(...stmDetails[i]);
          }
        }
      });
    }
    return {
      countOfConflicts: countConflicts,
      countOfOvertime: countOvertime,
      dailyConflicts,
      dailyConflictDetails,
    };
  }

  function countUnpublished() {
    let count = 0;

    if (all_data.actual_schedule) {
      let store_shifts = all_data.actual_schedule.filter(
        (v, i) => v.other_store === false
      );
      if (
        store_shifts?.length <
        all_data.published_shift_count?.count_of_published_shifts
      ) {
        count =
          all_data.published_shift_count?.count_of_published_shifts -
          store_shifts?.length;
      }
      store_shifts?.map((value, index) => {
        if (value.is_publishable === true) {
          count += 1;
        }
      });
    }
    return count;
  }

  let countOfWarnings = countWarnings();
  let countOfUnpublished = countUnpublished();

  // In monthly view, use the counts computed by MonthlySchedule
  if (viewMode === 'Month') {
    countOfUnpublished = monthlyCountOfUnpublished;
  }

  const week_already_started =
    new Date(week_start_date.toDateString()) <=
    new Date(new Date().toDateString());

  function getAverageWage(data) {
    if (data?.length === 0) {
      return 0;
    }

    let totalWage = 0;

    for (let i = 0; i < data?.length; i++) {
      totalWage += data?.[i].average_wage;
    }

    const averageWage = totalWage / data?.length;

    return averageWage;
  }

  const averageWageFromPreviousWeek = getAverageWage(
    all_data?.recent_avg_wages
  );

  const copilotShifts = all_data?.copilot_schedule?.filter(
    (shift) => shift?.is_copilot_suggestion
  );

  const copilotDeleteShifts = all_data?.copilot_schedule?.filter(
    (shift) => shift?.copilot_suggested_deletion
  );

  const laborLawViolations = all_data?.labor_law_violations;
  const restBreakRegulation = all_data?.rest_break_regulation;
  const mealBreakRegulation = all_data?.meal_break_regulation;

  // Use meal break regulation params when available, fall back to store
  // config. If neither is set, leave null so auto-add is disabled.
  // Mirrors backend MealBreakChecker._get_trigger_hours: prefer trigger_hours,
  // then derive from minimum_shift_hours - required_break_minutes/60.
  const effectiveBreakThreshold = mealBreakRegulation
    ? (mealBreakRegulation.trigger_hours
      ?? (mealBreakRegulation.minimum_shift_hours != null && mealBreakRegulation.required_break_minutes != null
        ? Math.max(mealBreakRegulation.minimum_shift_hours - mealBreakRegulation.required_break_minutes / 60, 0)
        : null))
      ?? props.breakRequiredWhenShiftLengthExceeds ?? null
    : props.breakRequiredWhenShiftLengthExceeds ?? null;
  const effectiveBreakLength = mealBreakRegulation?.required_break_minutes
    ? Math.ceil(mealBreakRegulation.required_break_minutes / 15) * 0.25
    : (props.defaultBreakLengthHours ?? 0.5);

  // Auto-reset showWarnings when all warnings are resolved so the user
  // isn't stuck in conflict-sort mode after the button disappears.
  useEffect(() => {
    if (showWarnings) {
      const hasStandardWarnings =
        countOfWarnings.countOfOvertime + countOfWarnings.countOfConflicts > 0;
      const hasLaborLawWarnings = laborLawViolations?.length > 0;
      if (!hasStandardWarnings && !hasLaborLawWarnings) {
        setShowWarnings(false);
      }
    }
  }, [showWarnings, countOfWarnings, laborLawViolations]);

  const publishedScheduleActionLog =
    all_data?.published_schedule_actions?.redux?.payload
      ?.published_schedule_actions;

  // template_names holds both granularities; split so each surface only shows
  // its own. NULL/missing template_type is legacy data, treated as weekly.
  const weeklyTemplateNames = template_names.filter(
    (t) => (t.template_type ?? "weekly") !== "daily"
  );
  const dailyTemplateNames = template_names.filter(
    (t) => t.template_type === "daily"
  );

  // Single bundle threaded down to the daily entry points (the Day-view Tools
  // menu + the weekly date-card dropdown) so we don't add six separate props
  // per surface. selectedDateStr/selectedDayInPast describe the day currently
  // shown in Day view (the date-card surface uses its own per-card date).
  const selectedDateStr = date ? formatDate(date.toString()) : null;
  const selectedDayInPast = date
    ? new Date(date.toDateString()) < new Date(new Date().toDateString())
    : false;
  const dailyTemplateProps = {
    dailyTemplateNames,
    saveDailyScheduleAsTemplate,
    loadDailyFromTemplate,
    deleteDailyScheduleTemplate,
    loadFromTemplateFinished,
    setLoadFromTemplateFinished,
    formatDate,
    selectedDateStr,
    selectedDayInPast,
    selectedDayShifts: (all_data.actual_schedule || []).filter(
      (s) => s.date === selectedDateStr
    ),
  };

  const overviewScheduleTarget = props.overviewScheduleNavigationTarget;
  const overviewScheduleTargetWeekStart = overviewScheduleTarget?.weekStart
    ? getStartOfCurrentWeek(
        props.businessWeekStartDayIndex,
        overviewScheduleTarget.weekStart
      )
    : null;
  const hasValidOverviewScheduleTargetWeek =
    overviewScheduleTargetWeekStart &&
    !isNaN(overviewScheduleTargetWeekStart.getTime());
  const isOverviewScheduleNavigationPending =
    Boolean(overviewScheduleTarget) &&
    (
      Number(overviewScheduleTarget.storeId) !== Number(store_id) ||
      !hasValidOverviewScheduleTargetWeek ||
      !isSameDate(overviewScheduleTargetWeekStart, week_start_date) ||
      loading
    );

  if (isOverviewScheduleNavigationPending) {
    return <ScheduleNavigationLoadingState />;
  }

  return (
    <div>
      {viewMode === 'Week' ? (
        <div>
          <TopBarDisplay
            showActualHours={scheduleActualHoursVisible}
            start_date={week_start_date}
            end_date={addDays(week_start_date, 6)}
            increment_week={increment_week}
            roleType={roleType}
            setRoleType={setRoleType}
            storeOptions={props.storeOptions}
            homeStore={props.homeStore}
            storeNames={props.storeNames}
            change_home_store={props.change_home_store}
            roleTypeOptions={roleTypeOptions}
            store_team_member_weekly_info={store_team_member_weekly_info}
            store_team_member_weekly_info_view={
              store_team_member_weekly_info_view
            }
            countOfWarnings={countOfWarnings}
            showWarnings={showWarnings}
            setShowWarnings={setShowWarnings}
            set_week_start_date={set_week_start_date}
            businessWeekStartDayIndex={props.businessWeekStartDayIndex}
            setView={setView}
            toggleDailyWeekly={toggleDailyWeekly}
            windowWidth={props.windowWidth}
            laborLawEnabled={props.laborLawEnabled}
            laborLawViolations={laborLawViolations}
          />
        </div>
      ) : viewMode === 'Day' ? (
        <div>
          <DailyTopBarDisplay
            date={date}
            increment_day={increment_day}
            start_date={week_start_date}
            end_date={addDays(week_start_date, 6)}
            increment_week={increment_week}
            roleType={roleType}
            setRoleType={setRoleType}
            storeOptions={props.storeOptions}
            homeStore={props.homeStore}
            storeNames={props.storeNames}
            change_home_store={props.change_home_store}
            roleTypeOptions={roleTypeOptions}
            store_team_member_weekly_info={store_team_member_weekly_info}
            store_team_member_weekly_info_view={
              store_team_member_weekly_info_view
            }
            countOfWarnings={countOfWarnings}
            showWarnings={showWarnings}
            setShowWarnings={setShowWarnings}
            set_week_start_date={set_week_start_date}
            businessWeekStartDayIndex={props.businessWeekStartDayIndex}
            setView={setView}
            toggleDailyWeekly={toggleDailyWeekly}
            windowWidth={props.windowWidth}
          />
        </div>
      ) : (
        <div>
          <MonthlyTopBarDisplay
            currentMonth={currentMonth}
            currentYear={currentYear}
            increment_month={increment_month}
            setCurrentMonth={setCurrentMonth}
            setCurrentYear={setCurrentYear}
            roleType={roleType}
            setRoleType={setRoleType}
            storeOptions={props.storeOptions}
            homeStore={props.homeStore}
            storeNames={props.storeNames}
            change_home_store={props.change_home_store}
            roleTypeOptions={roleTypeOptions}
            store_team_member_weekly_info={store_team_member_weekly_info}
            store_team_member_weekly_info_view={
              store_team_member_weekly_info_view
            }
            countOfWarnings={countOfWarnings}
            showWarnings={showWarnings}
            setShowWarnings={setShowWarnings}
            set_week_start_date={set_week_start_date}
            businessWeekStartDayIndex={props.businessWeekStartDayIndex}
            setView={setView}
            toggleDailyWeekly={toggleDailyWeekly}
            windowWidth={props.windowWidth}
            laborLawEnabled={props.laborLawEnabled}
            laborLawViolations={laborLawViolations}
          />
        </div>
      )}
      <button
        type="button"
        className="hidden"
        data-help-id="schedule-week-view"
        aria-label="Switch to week schedule view"
        onClick={() => setView('Week', 0)}
      />
      <button
        type="button"
        className="hidden"
        data-help-id="schedule-current-week-view"
        aria-label="Switch to current week schedule view"
        onClick={() => {
          const currentWeekStart = getStartOfCurrentWeek(
            props.businessWeekStartDayIndex,
            new Date()
          );
          const displayedWeekStart = new Date(week_start_date);
          displayedWeekStart.setHours(0, 0, 0, 0);

          if (displayedWeekStart.getTime() !== currentWeekStart.getTime()) {
            set_week_start_date(currentWeekStart);
          }
          setView('Week', 0);
        }}
      />
      <div className="w-full mt-5">
        <ActionBarDisplay2
          employeeSchedulingMembers={all_data.store_team_members}
          canManageEmployeeSchedulingPreferences={["company_manager", "company_admin", "rightwork_internal"].includes(props.permissionRole)}
          updatePersonInfo={updatePersonInfo}
          canOptimizeBreaks={["company_manager", "company_admin", "rightwork_internal"].includes(props.permissionRole)}
          breakOptimizationOptions={{
            date_start: formatDate(week_start_date?.toString()),
            locked_days: lockedDays.map((locked, index) => locked || (viewMode === "Day" && index !== dowSelected)),
            locked_people: Object.entries(lockedPeople).filter(([, locked]) => locked).map(([id]) => Number(id)),
            lock_all: Boolean(lockAllShifts),
          }}
          onBreaksApplied={async () => {
            invalidateOverviewCache();
            await fetch_data(SHIFT_MUTATION_REFRESH_API_CALLS, SHIFT_MUTATION_REFRESH_DATA_NAMES, false);
          }}
          actualComplianceAudit={actualComplianceAudit}
          actualAuditStartDate={scheduleWeekStartStr}
          actualAuditEndDate={formatDate(addDays(week_start_date, 6))}
          // Month renders and edits the plan regardless of the mode, so telling
          // the bar it is showing actuals would disable publishing over an
          // editable planned calendar.
          showActualHours={
            viewMode === "Month" ? false : scheduleActualHoursVisible
          }
          store_team_member_weekly_info_view={
            store_team_member_weekly_info_view
          }
          bottomCardType={bottomCardType}
          setBottomCardType={setBottomCardType}
          comparisonMetricVisibility={comparisonMetricVisibility}
          autosched_available={checkIfForecastAvail()}
          laborModelEnabled={props.laborModelEnabled}
          lockAllShifts={lockAllShifts}
          setLockAllShifts={toggleLockAllShifts}
          get_t_str={get_t_str}
          week_already_started={week_already_started}
          week_ended={
            new Date(addDays(week_start_date, 6).toDateString()) <=
            new Date(new Date().toDateString())
          }
          fullWeekPastAutoscheduleEnabled={fullWeekPastAutoscheduleEnabled}
          addDays={addDays}
          loadFrom7Shift={loadFrom7Shifts}
          toggleDisplayMode={toggleDisplayMode}
          displayMode={displayMode}
          toggleMinimizeMode={toggleMinimizeMode}
          minimizeMode={minimizeMode}
          toggleShowWeeklySummaryCards={toggleShowWeeklySummaryCards}
          showWeeklySummaryCards={showWeeklySummaryCards}
          openCustomizeSummaryCards={() =>
            setCustomizeSummaryCardsOpen(true)
          }
          saveScheduleAsTemplate={saveScheduleAsTemplate}
          deleteScheduleTemplate={deleteScheduleTemplate}
          week_start_date={week_start_date}
          load7ShiftsScheduleFinished={load7ShiftsScheduleFinished}
          setLoad7ShiftsScheduleFinished={setLoad7ShiftsScheduleFinished}
          template_names={weeklyTemplateNames}
          dailyTemplateProps={dailyTemplateProps}
          formatDate={formatDate}
          loadFromTemplate={loadFromTemplate}
          loadFromTemplateFinished={loadFromTemplateFinished}
          setLoadFromTemplateFinished={setLoadFromTemplateFinished}
          filterTeam={filterTeam}
          filtered={filtered}
          sortTeam={sortTeam}
          sorted={sorted}
          setSorted={setSorted}
          segmentMode={segmentMode}
          setSegmentMode={setSegmentMode}
          reorderMode={reorderMode}
          toggleReorderMode={toggleReorderMode}
          showWarnings={showWarnings}
          setShowWarnings={setShowWarnings}
          autoSchedule={autoSchedule}
          acceptNewSchedule={acceptNewSchedule}
          schedule_differences={schedule_differences}
          autoScheduleFinished={autoScheduleFinished}
          autoScheduleError={autoScheduleError}
          setAutoScheduleError={setAutoScheduleError}
          setAutoScheduleFinished={setAutoScheduleFinished}
          acceptAutoScheduleFinished={acceptAutoScheduleFinished}
          setAcceptAutoScheduleFinished={setAcceptAutoScheduleFinished}
          deleteAllShifts={deleteAllShifts}
          scheduled_hours={scheduled_hours}
          loadedFrom7Shifts={loadedFrom7Shifts}
          loadedFromTemplate={loadedFromTemplate}
          loadedFromAuto={loadedFromAuto}
          publishShifts={publishShifts}
          roleType={roleType}
          roleTypeOptions={roleTypeOptions}
          publishShiftsFinished={publishShiftsFinished}
          setPublishShiftsFinished={setPublishShiftsFinished}
          pushedChanges={pushedChanges}
          weeklyView={viewMode === 'Week'}
          monthlyView={viewMode === 'Month'}
          dailyView={viewMode === 'Day'}
          dowSelected={dowSelected}
          monthName={monthNames[currentMonth]}
          store_team_member_weekly_info={store_team_member_weekly_info}
          actual_schedule={all_data.actual_schedule}
          scheduleLoading={loading}
          actual_schedule_labor={all_data.actual_schedule_labor_deployment}
          forecasted_labor={all_data.forecasted_labor}
          grade_weights={all_data.grade_weights}
          has7ShiftsIntegration={props.has7ShiftsIntegration}
          role_types={all_data.role_types}
          countOfWarnings={countOfWarnings}
          countOfUnpublished={countOfUnpublished}
          countOfPublished={
            viewMode === 'Month'
              ? monthlyCountOfPublished
              : all_data.published_shift_count?.count_of_published_shifts
          }
          role_names={all_data.role_names}
          showUnpublishedShifts={showUnpublishedShifts}
          setShowUnpublishedShifts={setShowUnpublishedShifts}
          notes={all_data.events}
          isCopilotOn={isCopilotOn}
          setIsCopilotOn={setIsCopilotOn}
          copilotShifts={copilotShifts}
          copilotDeleteShifts={copilotDeleteShifts}
          addMultipleShifts={addMultipleShifts}
          isAddingAllCopilotShiftsLoading={isAddingAllCopilotShiftsLoading}
          setIsAddingAllCopilotShiftsLoading={
            setIsAddingAllCopilotShiftsLoading
          }
          isCopilotLoading={isCopilotLoading}
          copilotEnabled={props.copilotEnabled}
          selectedWeekForMonthlyCopilot={selectedWeekForMonthlyCopilot}
          setSelectedWeekForMonthlyCopilot={setSelectedWeekForMonthlyCopilot}
          all_data={all_data}
          filter_df_to_day={filter_df_to_day}
          printHoursShownEnabled={props.printHoursShownEnabled}
          storeNames={props.storeNames}
          store_id={store_id}
          newScheduleInsights={newScheduleInsights}
          setNewScheduleInsights={setNewScheduleInsights}
          publishedScheduleActionLog={publishedScheduleActionLog}
          start_date={week_start_date}
          end_date={addDays(week_start_date, 6)}
          pos_provider={props.pos_provider}
          refreshActualsForDate={refreshActualsForDate}
          laborLawEnabled={props.laborLawEnabled}
          laborLawViolations={laborLawViolations}
          selectedRolesForFiltering={selectedRolesForFiltering}
          setSelectedRolesForFiltering={setSelectedRolesForFiltering}
          onScheduleReverted={handleScheduleReverted}
          currentMonth={currentMonth}
          currentYear={currentYear}
          businessWeekStartDayIndex={props.businessWeekStartDayIndex}
          canPublishSchedule={canPublishSchedule}
          publishScheduleReviewRequiredEnabled={
            props.publishScheduleReviewRequiredEnabled
          }
          blockPublishOnLaborViolationsEnabled={
            props.blockPublishOnLaborViolationsEnabled
          }
          windowWidth={props.windowWidth}
        />
      </div>
      <div className="w-full mt-5 pb-10">
        <ScheduleDisplay2
          actualComplianceAudit={actualComplianceAudit}
          printHoursShownEnabled={props.printHoursShownEnabled}
          openLiveAction={
            props.openLiveAction
              ? () =>
                  props.openLiveAction({
                    viewMode,
                    dowSelected,
                    currentMonth,
                    currentYear,
                  })
              : undefined
          }
          openDirectMessageWith={props.openDirectMessageWith}
          currentUserId={props.currentUserId}
          openEmployeeProfile={
            props.openEmployeeProfile
              ? (storeTeamMemberId) =>
                  props.openEmployeeProfile(storeTeamMemberId, {
                    viewMode,
                    dowSelected,
                    currentMonth,
                    currentYear,
                  })
              : undefined
          }
          bottomCardType={bottomCardType}
          setBottomCardType={setBottomCardType}
          opsRefreshSignal={props.opsRefreshSignal}
          summaryCardOrder={summaryCardOrder}
          countOfWarnings={countOfWarnings}
          store_team_member_weekly_info={store_team_member_weekly_info}
          store_team_member_weekly_info_view={
            store_team_member_weekly_info_view
          }
          lockAllShifts={lockAllShifts}
          get_t_str={get_t_str}
          filter_df_to_day={filter_df_to_day}
          agg_column={agg_column}
          formatDate={formatDate}
          all_data={all_data}
          all_data_full={all_data_full}
          start_date={week_start_date}
          checkedMetricsToggle={scheduleShowsActuals && actualHoursAvailable}
          actualHoursAvailable={actualHoursAvailable}
          setCheckedMetricsToggle={setScheduleShowsActuals}
          storeBusinessDate={scheduleStoreBusinessDate}
          weekStartStr={scheduleWeekStartStr}
          showActualHours={scheduleActualHoursVisible}
          weekHasStartedForActuals={scheduleWeekHasStarted}
          week_in_past={
            new Date(addDays(week_start_date, 6).toDateString()) <
            new Date(new Date().toDateString())
          }
          week_already_started={week_already_started}
          addShift={addShift}
          editAvailability={editAvailability}
          updatePersonInfo={updatePersonInfo}
          displayMode={displayMode}
          minimizeMode={minimizeMode}
          showWeeklySummaryCards={showWeeklySummaryCards}
          store_id={store_id}
          addDays={addDays}
          sorted={sorted}
          filtered={filtered}
          reorderMode={reorderMode}
          reorderTeamMembers={reorderTeamMembers}
          searchInput={searchInput}
          setSearchInput={setSearchInput}
          noMatchingSearch={noMatchingSearch}
          loading={loading}
          lockedDays={lockedDays}
          lock_day={lock_day}
          lockedPeople={lockedPeople}
          setLockedPeople={setLockedPeople}
          lock_person={lock_person}
          saveShiftFinished={saveShiftFinished}
          setSaveShiftFinished={setSaveShiftFinished}
          saveAvailabilityFinished={saveAvailabilityFinished}
          setSaveAvailabilityFinished={setSaveAvailabilityFinished}
          addForecastAdjustment={addForecastAdjustment}
          addManualActualSales={addManualActualSales}
          addAdjustmentFinished={addAdjustmentFinished}
          fetchManualIntradayDistribution={fetchManualIntradayDistribution}
          saveManualIntradayDistribution={saveManualIntradayDistribution}
          setCopiedShift={setCopiedShift}
          copiedShift={copiedShift}
          addMultipleShifts={addMultipleShifts}
          toggleDailyWeekly={toggleDailyWeekly}
          dailyTemplateProps={dailyTemplateProps}
          weeklyView={viewMode === 'Week'}
          monthlyView={viewMode === 'Month'}
          dowSelected={dowSelected}
          selectedRolesForFiltering={selectedRolesForFiltering}
          currentMonth={currentMonth}
          currentYear={currentYear}
          setCurrentMonth={setCurrentMonth}
          setCurrentYear={setCurrentYear}
          edit_hoo={edit_hoo}
          saveEvent={saveEvent}
          updateEvent={updateEvent}
          deleteEvent={deleteEvent}
          eventAttachmentProps={eventAttachmentProps}
          saveEventFinished={saveEventFinished}
          setSaveEventFinished={setSaveEventFinished}
          saveForecastExcludeDate={saveForecastExcludeDate}
          deleteForecastExcludeDate={deleteForecastExcludeDate}
          blackout_dates={blackout_dates}
          saveBlackoutDate={saveBlackoutDate}
          deleteBlackoutDate={deleteBlackoutDate}
          businessWeekStartDayIndex={props.businessWeekStartDayIndex}
          start_qhnum={props.start_qhnum}
          schedule_day_end_qhnum={props.schedule_day_end_qhnum}
          storeTimezone={props.storeTimezone}
          homeCompany={props.homeCompany}
          loadEmployeePreviousSchedule={loadEmployeePreviousSchedule}
          showLaborPercent={showLaborPercent}
          averageWageFromPreviousWeek={averageWageFromPreviousWeek}
          laborPercentData={all_data?.get_spent_labor_daily_summaries}
          frequentShifts={all_data.frequent_schedules?.redux?.payload?.map}
          roleType={roleType}
          setRoleType={setRoleType}
          roleTypeOptions={roleTypeOptions}
          historicalSalesContext={
            historical_sales_context?.redux?.payload?.data
          }
          post_missed_shift={post_missed_shift}
          breakWaiverEnabled={props.breakWaiverEnabled}
          showUnpublishedShifts={showUnpublishedShifts}
          request_time_off={request_time_off}
          defaultBreakLengthHours={effectiveBreakLength}
          windowWidth={props.windowWidth}
          tplhEnabled={props.tplhEnabled}
          editShiftsInPastEnabled={props.editShiftsInPastEnabled}
          isCopilotOn={isCopilotOn}
          setIsCopilotOn={setIsCopilotOn}
          isCopilotLoading={isCopilotLoading}
          copilotEnabled={props.copilotEnabled}
          selectedWeekForMonthlyCopilot={selectedWeekForMonthlyCopilot}
          setSelectedWeekForMonthlyCopilot={setSelectedWeekForMonthlyCopilot}
          isAddingAllCopilotShiftsLoading={isAddingAllCopilotShiftsLoading}
          setIsAddingAllCopilotShiftsLoading={setIsAddingAllCopilotShiftsLoading}
          delete_time_off_request={delete_time_off_request}
          delete_temporary_availability={delete_temporary_availability}
          highlightedEmployees={highlightedEmployees}
          breakRequiredWhenShiftLengthExceeds={
            effectiveBreakThreshold
          }
          secondBreakShiftLengthThreshold={
            props.secondBreakShiftLengthThreshold
          }
          proficiencyStarsCount={props.proficiencyStarsCount}
          proficiencyFromLMSEnabled={props.proficiencyFromLMSEnabled}
          laborModelEnabled={props.laborModelEnabled}
          laborLawViolations={laborLawViolations}
          laborLawEnabled={props.laborLawEnabled}
          guestReviewsEnabled={props.guestReviewsEnabled}
          liveLaborEnabled={props.liveLaborEnabled}
          paidBreakInputsEnabled={props.paidBreakInputsEnabled}
          businessDeclineShiftOptionEnabled={props.businessDeclineShiftOptionEnabled}
          restBreakRegulation={restBreakRegulation}
          manualSalesInputEnabled={props.manualSalesInputEnabled}
          dailyPlanEnabled={props.dailyPlanEnabled}
          refreshActualsForDate={refreshActualsForDate}
          refreshActualUsedSchedule={refreshActualUsedSchedule}
          pos_provider={props.pos_provider}
          publishShiftsFinished={publishShiftsFinished}
          setMonthlyCountOfUnpublished={setMonthlyCountOfUnpublished}
          setMonthlyCountOfPublished={setMonthlyCountOfPublished}
        />
      </div>

      {/* Debug modal for autoscheduler stats (only renders when debug_stats available) */}
      <AutoschedulerDebugModal />

      <CustomizeSummaryCardsModal
        open={customizeSummaryCardsOpen}
        onClose={() => setCustomizeSummaryCardsOpen(false)}
        currentOrder={summaryCardOrder}
        laborLawEnabled={props.laborLawEnabled}
        onSaved={(newOrder) => setSummaryCardOrder(newOrder)}
      />
    </div>
  );
}

export default HomeDisplay2;
